<template>
  <div class='year atb-flex atb-flex-column'>
    <div class='header atb-flex atb-flex-items-center'>
      <div class='year-title'>
        <h2>{{this.summaryData.resWkName? this.summaryData.title + ' / ' + this.summaryData.resWkName: ''}}</h2>
        <span class="saveStatus">{{saveStatus}}</span>
      </div>
    </div>
    <div class='container search-and-content atb-content-bg atb-flex atb-flex-column' id="year-wrap">
      <div class='search'>
        <el-form v-if="expandSearchStatus" :inline="true" :model="searchParam" class="atb-input search-input" @keyup.enter.native="getList" @submit.native.prevent>
          <el-form-item class="flex-form-item" label="类别">
             <el-autocomplete v-model="searchParam.WorkItemCategory" :fetch-suggestions="queryCategory" placeholder="类别" clearable></el-autocomplete>
          </el-form-item>
          <el-form-item class="flex-form-item" label="分类">
            <el-select v-model="searchParam.WorkClassify" placeholder="分类" clearable>
              <el-option v-for="item in classifyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="flex-form-item" label="状态">
            <el-select v-model="searchParam.Status" placeholder="状态" clearable>
              <el-option v-for="item in completeList" :key="item.id" :label="item.itemDesc" :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="flex-form-item" label="关键字">
            <el-input v-model="searchParam.KeyWord" placeholder="工作项目" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
          </el-form-item>
        </el-form>
        <div class="function atb-flex">
          <el-form :inline="true" class="atb-input model">
            <el-form-item>
              <el-radio-group v-model="model" @change="changeModel">
                <el-radio label="1">完整模式</el-radio>
                <el-radio label="2">计划模式</el-radio>
                <el-radio label="3">半年总结</el-radio>
                <el-radio label="4">全年总结</el-radio>
                <el-radio label="5">汇报模式</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <el-form :inline="true" class="atb-input">
            <el-form-item v-if="editStatus == 'edit' && status !== 10">
              <el-button :disabled="pending" type="primary" @click="saveAll">保存</el-button>
            </el-form-item>
            <el-form-item v-if="editStatus == 'edit'&& (status ===0||status ===30)">
              <el-button :disabled="pending" type="primary" @click="copyPreviousYearPlan">复制</el-button>
            </el-form-item>
            <el-form-item v-if="editStatus==='edit'">
              <el-button type="primary"  @click="showSubmit = true">提交</el-button>
            </el-form-item>
            <el-form-item v-if="editStatus==='edit' || editStatus==='manage'">
              <el-button type="import" plain @click="exportExcel">导出</el-button>
            </el-form-item>
            <el-form-item v-if="editStatus==='edit'&& (status ===0||status ===30)">
              <el-upload 
                ref="file"
                :http-request="uploadFile"
                :multiple="false"
                :show-file-list='false'
              >
              <el-button plain type="import">导入</el-button>
            </el-upload>
            </el-form-item>
            <el-form-item v-if="editStatus==='edit'&& (status ===0||status ===30)">
              <el-button plain type="downloadTemplate" @click="downloadTemplate">下载模板</el-button>
            </el-form-item>
            <el-form-item v-if="this.editStatus==='approve'">
              <el-button type="primary" @click="showApprove=true">通过</el-button>
            </el-form-item>
            <el-form-item v-if="this.editStatus==='approve'">
              <el-button type="refuse" @click="showCompleteApprove=true">驳回</el-button>
            </el-form-item>
            <el-form-item>
              <el-button plain type="downloadTemplate" @click="expandRowAll">{{expandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
            </el-form-item>
            <el-form-item v-if="editStatus==='edit'&& (status ===0||status ===30)">
              <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
                <el-button type="import" plain class="menu-button">
                  批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item command="a">开始日期</el-dropdown-item>
                  <el-dropdown-item command="b">最终完成日期</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
            <el-form-item v-if="editStatus==='manage'">
              <el-button type="downloadTemplate" plain @click="preciseExport">精确导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="open" @click="expandSearch">
          筛选
          <i :class="[expandSearchStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
        </div>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <div v-show="showCollapse" class="collapse" @click="collapse($refs.year, tableColumn)">
          <i :class="[isCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          class='atb-table header-table edit-table border-table disable-ellipsis'
          border='full'
          height='100%'
          auto-resize
          resizable
          :data="tableData"
          ref="year"
          :merge-cells="mergeCells"
          :row-class-name="setRowClass"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @edit-actived="activeRow"
          @cell-click="expandRow"
          :edit-rules="validRules"
        >
          <vxe-table-column type='checkbox' width='40' align='center' enabled: enabled>
            <template #checkbox="scope">
              <template v-if="scope.rowIndex === 0">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                     <i @click="expandKpi" :class="[expandKpiStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                     <span @click="expandKpi">重要KPI</span>
                     <i v-throttle v-if='(status === 0 || status === 30)&&editStatus==="edit"' @click="addKpi" class="icon-add"></i>
                  </div>
                  <span v-throttle v-if='(status === 0 || status === 30)&&editStatus==="edit"' @click='addKpi(scope.row)'>新增</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + 1">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                   <div>
                     <i @click="expandNormal" :class="[expandNormalStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                     <span @click="expandNormal">业务工作</span>
                     <i v-throttle v-if='(status === 0 || status === 30)&&editStatus==="edit"' @click="addNormal" class="icon-add"></i>
                   </div>
                  <span v-throttle v-if='(status === 0 || status === 30)&&editStatus==="edit"' @click='addNormal'>新增</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + 2">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                    <i @click="expandCreate" :class="[expandCreateStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandCreate">费效管理</span>
                    <i v-throttle v-if='(status === 0 || status === 30)&&editStatus==="edit"' @click="addCreate" class="icon-add"></i>
                  </div>
                  <span v-throttle v-if='(status === 0 || status === 30)&&editStatus==="edit"' @click='addCreate'>新增</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + createLength + 3">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                    <i @click="expandHr" :class="[expandHrStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandHr">人力资源</span>
                  </div>
                </div>
              </template>
                <template v-else-if="scope.rowIndex === kpiLength + normalLength + createLength + hrLength + 4">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                    <i @click="expandCc" :class="[expandCcStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandCc">企业文化</span>
                  </div>
                </div>
              </template>
                <template v-else-if="scope.rowIndex === kpiLength + normalLength + createLength + hrLength + ccLength + 5">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                    <i @click="expandPg" :class="[expandPgStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandPg">个人成长</span>
                     <i v-throttle v-if='(status === 0 || status === 30)&&editStatus==="edit"' @click="addPg" class="icon-add"></i>
                  </div>
                  <span v-throttle v-if='(status === 0 || status === 30)&&editStatus==="edit"' @click='addPg'>新增</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + createLength + hrLength + ccLength + pgLength + 6">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <div>
                    <i @click="expandOther" :class="[expandOtherStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandOther">其他新增工作</span>
                     <!-- <i v-if='status === 0 || status === 30' @click="addOther" class="icon-add"></i> -->
                  </div>
                  <!-- <span v-if='status === 0 || status === 30' @click='addOther'>新增</span> -->
                </div>
              </template>
              <template v-else>
                <span v-if="status!==10" title="选择/取消" :class="['vxe-cell--checkbox', scope.checked ? 'is--checked' : '']" @click.stop="selectSingle(scope.row)">
                  <span class="vxe-checkbox--icon vxe-checkbox--checked-icon"></span>
                  <span class="vxe-checkbox--icon vxe-checkbox--unchecked-icon"></span>
                  <span class="vxe-checkbox--icon vxe-checkbox--indeterminate-icon"></span>
                </span>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemNo" min-width="50" title="NO." align="center">
            <template #default="scope">
              <span v-if="scope.rowIndex <= kpiLength">{{scope.rowIndex}}</span>
              <span v-else-if="scope.rowIndex > kpiLength + 1 && scope.rowIndex <= normalLength + kpiLength + 2">{{scope.rowIndex - kpiLength - 1}}</span>
              <span v-else-if="scope.rowIndex > normalLength + kpiLength + 2 && scope.rowIndex <= normalLength + kpiLength + createLength + 3">{{scope.rowIndex - kpiLength - normalLength - 2}}</span>
              <span v-else-if="scope.rowIndex > normalLength + kpiLength + createLength + 3 && scope.rowIndex <= normalLength + kpiLength + createLength + hrLength + 4">{{scope.row.workItemNo}}</span>
              <span v-else-if="scope.rowIndex > normalLength + kpiLength + createLength + hrLength + 4 && scope.rowIndex <= normalLength + kpiLength + createLength + hrLength + ccLength + 5">{{scope.row.workItemNo}}</span>
              <span v-else-if="scope.rowIndex > normalLength + kpiLength + createLength + hrLength + ccLength + 5 && scope.rowIndex <= normalLength + kpiLength + createLength + hrLength + ccLength + pgLength + 6">{{scope.rowIndex - kpiLength - normalLength - createLength - hrLength - ccLength - 5}}</span>
              <span v-else>{{scope.rowIndex - kpiLength - createLength - normalLength - hrLength - ccLength - pgLength - 6}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemCategory" min-width="60" title="类别" :edit-render="{name: 'ElAutocomplete', enabled: enabledWorkItemCategory, autofocus: '.el-textarea__inner'}">
             <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.workItemCategory}}</div>
            </template>
            <template #edit="{ row }">
             <el-autocomplete v-model="row.workItemCategory" type="textarea" :autosize="{ maxRows: 8 }" :fetch-suggestions="queryCategory" >
               <template slot-scope="{ item }">
                <el-tooltip
                  class="item"
                  effect='dark'
                  :content="item.value"
                  placement="right-start"
                >
                 <div class="query-item-text atb-ellipsis">{{ item.value }}</div>
                </el-tooltip>
               </template>
             </el-autocomplete>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent" title="工作项目" min-width="100" :width="model == 5 ? null : 150" :edit-render="{ enabled: enabledExcep, autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.workItemContent" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
            <template #default="scope">
              <div :class="[scope.row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{scope.row.workItemContent}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="fullTarget" min-width="100" :width="model == 4 ? null : 250" title="全年目标" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledFullTarget}">
             <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.fullTarget}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.fullTarget" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
           <vxe-table-column field="resWkName" min-width="80" title="责任人" :edit-render="{autofocus: '.el-textarea__inner', enabled: false}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize v-model="row.resWkName"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="weight" min-width="80" title="权重(%)" :edit-render="{autofocus: '.el-input__inner', enabled: enabledExcep}">
            <template #edit="{ row }">
              <el-autocomplete v-model.number="row.weight" :fetch-suggestions="querySearchWeight" :min="1" @change="validateWeight(row)" oninput="value=value.replace(/[^\.\d]/g,'')"></el-autocomplete>
            </template>
            <template #default="{ row }">
              <span v-if="row.workClassify===30">{{row.weightTemp}}</span>
              <span v-else>{{row.weight}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="startDate" title="开始日期" min-width="100" :edit-render="{autofocus: '.el-input__inner', enabled: enabled}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.startDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.startDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="finishDate" title="最终完成日期" min-width="120" :edit-render="{autofocus: '.el-input__inner', enabled: enabled}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="firstHalfTarget" min-width="120" :width="model == 5 ? null : 250" title="上半年目标" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledHalfTarget}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.firstHalfTarget}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.firstHalfTarget" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="firstHalfSummary" min-width="120" :width="model == 5 ? null : 250" title="上半年总结" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledFhs}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.firstHalfSummary}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.firstHalfSummary" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="finishFullTarget" min-width="100" :width="model == 5 ? null : 250" title="全年目标" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledFinishFullTarget}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.finishFullTarget}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.finishFullTarget" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="fullSummary" min-width="100" :width="model == 5 ? null : 250" title="全年总结" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledFs}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.fullSummary}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.fullSummary" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
           <vxe-table-column field="creatorId" min-width="70" title="新增人" :edit-render="{autofocus: '.el-textarea__inner', enabled: false}" v-if="false">
            <template #edit="{ row }">
              <el-input type='textarea' autosize v-model="row.creatorId"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remark" min-width="80" title="备注" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledFullTarget || enabledHalfTarget || enabledFinishFullTarget || enabledFs || enabledFhs}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remark}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.remark" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="提交状态" min-width="150" fixed="right">
            <template #default="{ row }">
              <el-tag
                v-if='row.status === 0'
                type="complete"
                effect="dark">
               {{getStatusName(row.status)}}
              </el-tag>
              <el-tag
                v-if='row.status === 10'
                type="complete"
                effect="dark">
               {{getStatusName(row.status)}}
              </el-tag>
              <el-tag
                v-if='row.status === 20'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag
                v-if='row.status === 30'
                type="close"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
                <el-tag
                v-if='row.status === 35'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag
                v-if='row.status === 40'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag 
                v-if='row.status === 50'
                type="close"
                effect="dark">
                 {{getStatusName(row.status)}}
                </el-tag>
                <el-tag
                v-if='row.status === 55'
                type="complete"
                effect="dark">
                 {{getStatusName(row.status)}}
                </el-tag>
              <el-tag
                v-if='row.status === 60'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag 
                v-if='row.status === 70'
                type="close"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
                <el-popover
                  v-if="row.status === 30 || row.status === 50 || row.status === 70" 
                  placement="top"
                  width="300"
                  trigger="hover"
                  popper-class="reason"
                  :visible-arrow='false'>
                    <div>
                      {{row.approveReason || '无'}}
                    </div>
                      <span slot="reference" class='program-tip reason'>
                      <i class='icon-hint'></i>
                    </span>
                  </el-popover>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="185" field="operation" title="操作" fixed="right" class-name='operation'>
            <template #default="scope">
              <div v-if='(scope.row.status === 0 || scope.row.status === 30) && scope.row.workClassify !== 30 && scope.row.workClassify !== 40 && editStatus == "edit"'>
                <el-tooltip class='item' effect='dark' content='复制' placement="bottom">
                  <i v-throttle class='icon-copy' @click.stop='copyData(scope.row, scope.rowIndex).then(()=>{editActived({row:scope.row,rowIndex:scope.rowIndex})})'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                  <i v-throttle class='icon-close delete' @click.stop='deleteData(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='切换分类' placement="bottom">
                  <i v-if="scope.row.id" class='icon-move' @click.stop='move(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
              </div>
              <div v-if='scope.row.status === 20 || scope.row.status==40 || scope.row.status==50 || scope.row.status==70'>
                <el-tooltip v-if="editStatus==='edit'" class='item' effect='dark' content='提交' placement="bottom">
                  <i class='icon-send' @click.stop='commitComplete(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
                <el-tooltip v-if='scope.row.workClassify === 30 && scope.row.workClassify === 40' class='item' effect='dark' content='删除' placement="bottom">
                  <i class='icon-close delete' @click.stop='deleteData(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
              </div>
              <div v-if='(scope.row.status === 35 || scope.row.status === 55) && editStatus==="approve" && editStatus == "approve"'>
                <el-tooltip class='item' effect='dark' content='通过' placement="bottom">
                  <i class='icon-definite' @click.stop='complete(scope.row, scope.rowIndex, "access")'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='驳回' placement="bottom">
                  <i class='icon-overruled' @click.stop='complete(scope.row, scope.rowIndex, "refuse")'></i>
                </el-tooltip>
                <el-tooltip v-if='scope.row.workClassify === 30 && scope.row.workClassify === 40' class='item' effect='dark' content='删除' placement="bottom">
                  <i class='icon-close delete' @click.stop='deleteData(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <el-dialog title="批量处理" :visible.sync="showHandle" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定全部处理吗?</h2>
        <p>处理过之后就不能再修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="showHandle = false">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提交" :visible.sync="showSubmit" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要提交吗?</h2>
        <p>{{tipMsg}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showSubmit = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="转移工作分类" :visible.sync="showHandle" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <el-radio-group v-model="classify">
          <el-radio-button :key="item.label + item.value" v-for="item in moveClassifyList" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmClassify">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    <context-menu :data="tableColumn" :selector="`.year .vxe-header--row`" @columnHideToggle="columnHideToggle"></context-menu>
    <el-dialog title="审批意见" :visible.sync="showApprove" width="500px" @close="closeApprove" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
      <el-input
        type="textarea"
        :autosize="{ minRows: 5 }"
        placeholder="审批通过原因可不填"
        v-model="approveReason">
      </el-input>
        <fast-approve @approveText="approveText"></fast-approve>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="updateStatus('access')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showApprove = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="审批意见" :visible.sync="showCompleteApprove" width="500px" @close="closeApprove" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
      <el-input
        type="textarea"
        :autosize="{ minRows: 5 }"
        placeholder="审批驳回原因必须填写"
        v-model="rejectReason">
      </el-input>
        <fast-approve @approveText="rejectText"></fast-approve>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="updateStatus('refuse')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showCompleteApprove = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="addSyncDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :command="dialogContent.command" :completeList="completeList" :selectData="selecterData" :editData="editData" @submitSuccess="copyLast()"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import qs from 'qs'
  import XEUtils from 'xe-utils'
  import _ from 'lodash';
  import routeMixin from '@/mixins/route.mixin'

  export default {
    components: {
     addSync:()=>import('./addSync.vue'),
     batchEdit: () => import('./batchEdit.vue'),
     export: () => import('./export.vue'),
    },
    name: "index",
    mixins: [routeMixin],
    data() {
      const workItemContent = ({cellValue, row}) => {
        if (!cellValue && (row.status===0||row.status===30)) {
          return new Error('工作项目不能为空')
        }
      }
      const fullTarget = ({cellValue, row}) => {
        if (!cellValue && (row.status===0||row.status===30)) {
          return new Error('全年目标不能为空')
        }
      }
      const weight = ({cellValue, row}) => {
        if (!cellValue && (row.status===0||row.status===30)) {
          return new Error('权重不能为空')
        }
      }
      const startDate = ({cellValue, row}) => {
        if (!cellValue && (row.status===0||row.status===30)) {
          return new Error('开始日期不能为空')
        }
        else{
          if(row.finishDate&&(row.status===0||row.status===30)){
             if(XEUtils.timestamp(cellValue)>XEUtils.timestamp(row.finishDate)){
                return new Error('开始日期不能大于最终完成日期')
             }
          }
        }
      }
      const finishDate = ({cellValue, row}) => {
        if (!cellValue && (row.status===0||row.status===30)) {
          return new Error('最终完成日期不能为空')
        }else{
          if(row.startDate&&(row.status===0||row.status===30)){
             if(XEUtils.timestamp(cellValue)<XEUtils.timestamp(row.startDate)){
                return new Error('最终完成日期不能小于开始日期')
             }
          }
        }
      }
      const firstHalfTarget = ({cellValue, row}) => {
        if (!cellValue && (row.status===0||row.status===30||row.status===20||row.status===50)) {
          return new Error('上半年目标不能为空')
        }
      }
      const finishFullTarget = ({cellValue, row}) => {
        if (!cellValue && (row.status===0||row.status===30)) {
          return new Error('全年目标不能为空')
        }
      }
      const firstHalfSummary = ({cellValue, row}) => {
        if (!cellValue && (row.status===20||row.status===50)) {
          return new Error('上半年总结不能为空')
        }
      }
      const fullSummary = ({cellValue, row}) => {
        if (!cellValue && (row.status===40||row.status===70)) {
          return new Error('全年总结不能为空')
        }
      }
      return {
        validRules: {
          workItemContent: [
            { required: true,validator: workItemContent,message:'工作项目不能为空' }
          ],
          fullTarget: [
            { required: true,validator: fullTarget,message:'全年目标不能为空' }
          ],
          weight: [
            { required: true,validator: weight,message:'权重不能为空' }
          ],
          startDate: [
            { required: true,validator: startDate,message:'开始时间不能为空' }
          ],
          finishDate: [
            { required: true,validator: finishDate,message:'最终完成时间不能为空' }
          ],
          firstHalfTarget: [
            { required: true,validator: firstHalfTarget,message:'上半年目标不能为空' }
          ],
          finishFullTarget: [
            { required: true,validator: finishFullTarget,message:'全年目标不能为空' }
          ],
          firstHalfSummary: [
            { required: true,validator: firstHalfSummary,message:'上半年总结不能为空' }
          ],
          fullSummary: [
            { required: true,validator: fullSummary,message:'全年总结不能为空' }
          ],
          resWkName:[
            { required: true }
          ]
        },
        workId: '',
        childIds: "",
        classify: '',
        showHandle: false,
        showSubmit: false,
        handleDelete: true,
        searchParam: {
          WorkItemCategory: null,
          WorkClassify: null,
          KeyWord: null,
          CompleteStatus: null
        },
        enabled: true,
        enabledFs: true,
        enabledFhs: true,
        enabledExcep: true,
        allowEdit: true,
        mergeCells: [
          {row: 0, col: 0, rowspan: 1, colspan: 16},
          {row: 1, col: 0, rowspan: 1, colspan: 16},
          {row: 2, col: 0, rowspan: 1, colspan: 16},
          {row: 3, col: 0, rowspan: 1, colspan: 16},
          {row: 4, col: 0, rowspan: 1, colspan: 16},
          {row: 5, col: 0, rowspan: 1, colspan: 16},
          {row: 6, col: 0, rowspan: 1, colspan: 16},
        ],
        result: {},
        kpi: [],
        normal: [],
        create: [],
        hr:[
          {workItemNo:'1',workItemCategory:'风控', workItemContent:'落实公司各项人力资源制度、流程，保证部门内各项人力资源管理操作程序合规合法，规避经济损失。',fullTarget:'如因部门人事管理不规范给公司造成经济损失的，相应责任人需承担该经济损失，并视情况严重程度给予处罚。',weight:'5',firstHalfTarget:'未出现人事管理不规范给公司造成损失。', finishFullTarget:'未出现人事管理不规范给公司造成损失。'},
          {workItemNo:'1',workItemCategory:'风控', workItemContent:'劳动安全：制定劳动安全管理机制，避免员工职业伤害。',fullTarget:'不出现严重工伤、工亡。',weight:'5',firstHalfTarget:'不出现严重工伤、工亡。', finishFullTarget:'不出现严重工伤、工亡。'},
          {workItemNo:'1',workItemCategory:'风控', workItemContent:'用工风险：遵循劳动法建立有效措施减少用工矛盾。',fullTarget:'不出现劳动仲裁、诉讼等事件。',weight:'5',firstHalfTarget:'不出现劳动仲裁、诉讼等事件。', finishFullTarget:'不出现劳动仲裁、诉讼等事件。'},
          {workItemNo:'2',workItemCategory:'人才梯队建设', workItemContent:'依据公司战略优化组织结构，提升人员效率。',fullTarget:'每年对组织结构进行一次优化，不存在不合理设置，效率提升15%以上。',weight:'5',firstHalfTarget:'不存在不合理设置。', finishFullTarget:'不存在不合理设置，效率提升15%以上。'},
          {workItemNo:'2',workItemCategory:'人才梯队建设', workItemContent:'建立部门人才晋升体系，在公司内部营造公平、公正、公开的竞争机制，规范公司员工的晋升、晋级工作流程。',fullTarget:'制定标准化晋升机制。',weight:'5',firstHalfTarget:'制定标准化晋升机制，规范晋升流程。', finishFullTarget:'制定标准化晋升机制，规范晋升流程。'},
          {workItemNo:'2',workItemCategory:'人才梯队建设', workItemContent:'建立部门人才培养体系，营造学习型组织，实现组织与员工共同成长。',fullTarget:'1-2名重点人才培养。',weight:'5',firstHalfTarget:'确定培养重点人员及培养方向。', finishFullTarget:'培养重点人才1-2名。'},
          {workItemNo:'3',workItemCategory:'薪酬管理', workItemContent:'内部薪酬保密性、公平性、合理性。',fullTarget:'1、不出现薪酬泄密事件。2、每年审核一次部门薪酬水平，结合统一要求制定公平合理的薪酬标准。',weight:'15',firstHalfTarget:'1、不出现薪酬泄密事件；2、每年审核一次部门薪酬水平，结合统一要求制定公平合理的薪酬标准。', finishFullTarget:'1、不出现薪酬泄密事件；2、每年审核一次部门薪酬水平，结合统一要求制定公平合理的薪酬标准。'},
          {workItemNo:'4',workItemCategory:'OEC管理', workItemContent:'自我OEC执行。',fullTarget:'准时准确完成自我OEC执行。',weight:'7',firstHalfTarget:'准时准确完成自我OEC执行。', finishFullTarget:'准时准确完成自我OEC执行。'},
          {workItemNo:'4',workItemCategory:'OEC管理', workItemContent:'所辖部门人员OEC管理。',fullTarget:'1、考核不遗漏，有明确、量化的考核指标；2、重点人员绩效沟通：对连续三个月及以上为C人员进行100%沟通，帮助制定绩效改进计划，并持续关注；3、按公司要求时间、要求比例提交各项考核结果。',weight:'8',firstHalfTarget:'1、考核不遗漏，有明确、量化的考核指标；2、重点人员绩效沟通：对连续三个月及以上为C人员进行100%沟通，帮助制定绩效改进计划，并持续关注；3、按公司要求时间、要求比例提交各项考核结果。', finishFullTarget:'1、考核不遗漏，有明确、量化的考核指标；2、重点人员绩效沟通：对连续三个月及以上为C人员进行100%沟通，帮助制定绩效改进计划，并持续关注；3、按公司要求时间、要求比例提交各项考核结果。'},
          {workItemNo:'5',workItemCategory:'招聘管理', workItemContent:'编制控制。',fullTarget:'结合工作实际情况拟聘人员，不超出年初规划编制。',weight:'15',firstHalfTarget:'结合工作实际情况拟聘人员，不超出年初规划编制。', finishFullTarget:'结合工作实际情况拟聘人员，不超出年初规划编制'},
          {workItemNo:'6',workItemCategory:'培训管理', workItemContent:'自我培训。',fullTarget:'每年度至少完成公司安排的对应级别的相应培训。',weight:'5',firstHalfTarget:'完成公司安排的对应级别的相应培训。', finishFullTarget:'完成公司安排的对应级别的相应培训。'},
          {workItemNo:'6',workItemCategory:'培训管理', workItemContent:'有针对性的对所辖人员进行培训，补短板，调整培训重点，提升部门整体水平。',fullTarget:'1、建立部门培训体系，所覆盖人员达70%；2、建立部门晋升培训体系，培训计划完成率100%，以当年度实际受训层级的课程为准。',weight:'5',firstHalfTarget:'完成上半年培训计划，根据实际情况及时调整培训方向。', finishFullTarget:'对晋升培训体系相关课程进行梳理，并依据当年度执行情况及次年规划对课程体系进行调整优化。'},
          {workItemNo:'7',workItemCategory:'员工关系', workItemContent:'员工关怀：关注员工成长，特别是核心员工，提高核心员工留存率。',fullTarget:'1、深入了解一线员工、骨干员工需求，定期开展座谈会、沟通交流会2、关注在岗员工情况，特别是三期员工，如有失联、旷工等异常，及时处理，必要时第一时间上报。',weight:'7',firstHalfTarget:'1、至少参与1次员工座谈会、沟通交流会。2、关注在职员工情况，及时处理异常情况，无遗漏。', finishFullTarget:'1、至少参与2次员工座谈会、沟通交流会。2、关注在职员工情况，及时处理异常情况，无遗漏。'},
          {workItemNo:'7',workItemCategory:'员工关系', workItemContent:'做好部门离职管理，合理优化人员。',fullTarget:'1、年度离职率不高于10%；淘汰率不低于5%；2、做好离职沟通，关注离职人员情绪。',weight:'8',firstHalfTarget:'1、年度离职率不高于5%；淘汰率不低于2.5%；2、做好离职沟通，如离职人员有负面情绪，给予疏导、安抚。', finishFullTarget:'1、年度离职率不高于10%；淘汰率不低于5%；2、做好离职沟通，如离职人员有负面情绪，给予疏导、安抚。'},
        ],
        cc:[
          {workItemNo:'1',workItemCategory:'组织建设', workItemContent:'各中心（子公司）拥有企业文化宣传员',fullTarget:'每缺少一人-5分',weight:'10', firstHalfTarget: '每缺少一人-5分', finishFullTarget:'每缺少一人-5分'},
          {workItemNo:'1',workItemCategory:'组织建设', workItemContent:'企业文化宣传、通知、中心（分公司）每月大事提交等配合工作完成情况',fullTarget:'配合积极，表现突出每次+1。未按要求完成或未按时提交、配合程度较低每次-1分',weight:'10', firstHalfTarget: '配合积极，表现突出每次+1。未按要求完成或未按时提交、配合程度较低每次-1分', finishFullTarget:'配合积极，表现突出每次+1。未按要求完成或未按时提交、配合程度较低每次-1分'},
          {workItemNo:'2',workItemCategory:'文化培训', workItemContent:'企业文化培训100%全员覆盖，对培训记录表进行抽查',fullTarget:'未参与培训或未提交培训记录-5分',weight:'10',firstHalfTarget: '未参与培训或未提交培训记录-5分', finishFullTarget:'未参与培训或未提交培训记录-5分'},
          {workItemNo:'3',workItemCategory:'文化积分', workItemContent:'统计各中心员工企业文化积分情况，各中心员工企业文化积分和，按10:1比例加减分',fullTarget:'最多加10分',weight:'10',firstHalfTarget: '最多加10分', finishFullTarget:'最多加10分'},
          {workItemNo:'4',workItemCategory:'文化传播', workItemContent:'以每50人一篇稿件为基数，每半年统计，向《安图人》或其他征文投稿数量',fullTarget:'多投一篇加1分，最多加10分。未达到投稿数量-5分',weight:'10',firstHalfTarget: '多投一篇加1分，最多加10分。未达到投稿数量-5分', finishFullTarget:'多投一篇加1分，最多加10分。未达到投稿数量-5分'},
          {workItemNo:'4',workItemCategory:'文化传播', workItemContent:'每半年统计，向宣传部提供符合公司八大价值观的优秀案例的数量',fullTarget:'每篇案例故事加1分，最多加10分',weight:'10',firstHalfTarget: '每篇案例故事加1分，最多加10分', finishFullTarget:'每篇案例故事加1分，最多加10分'},
          {workItemNo:'5',workItemCategory:'文化活动', workItemContent:'积极参与公司级互动，统计各中心参与程度',fullTarget:'积极参与，表现突出每次+2分，最多加10分。未积极参与，每次-2分',weight:'10',firstHalfTarget: '积极参与，表现突出每次+2分，最多加10分。未积极参与，每次-2分', finishFullTarget:'积极参与，表现突出每次+2分，最多加10分。未积极参与，每次-2分'},
          {workItemNo:'5',workItemCategory:'文化活动', workItemContent:'各中心每年组织两次文化活动(含工会活动)',fullTarget:'积极组织活动，每次+5分，最多加10分。未积极参与，每次-5分',weight:'10',firstHalfTarget: '积极组织活动，每次+5分，最多加10分。未积极参与，每次-5分', finishFullTarget:'积极组织活动，每次+5分，最多加10分。未积极参与，每次-5分'},
          {workItemNo:'6',workItemCategory:'文化宣贯', workItemContent:'熟知企业宗旨、愿景、战略、精神、价值观和专项理念，采用每月、不同中心或部门进行问卷抽查方式进行考核，要求全员认知度在率90%以上',fullTarget:'低于90%，-5分',weight:'10',firstHalfTarget: '低于90%，-5分', finishFullTarget:'低于90%，-5分'},
          {workItemNo:'6',workItemCategory:'文化宣贯', workItemContent:'了解企业基础VI，熟知logo、辅助图形含义，要求全员认知度在率90%以上',fullTarget:'低于90%，-5分。',weight:'10',firstHalfTarget: '低于90%，-5分', finishFullTarget:'低于90%，-5分'},
        ],
        pg:[],
        other: [],
        record: {
          workId: '',
          workClassify: 0,
          workItemNo: '',
          workItemCategory: "",
          workItemContent: "",
          resWkNo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkNo : '',
          resWkName: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkName : '',
          fullTarget: "",
          weight: 1,
          startDate: "",
          finishDate: "",
          firstHalfTarget: "",
          firstHalfSummary: "",
          finishFullTarget: "",
          fullSummary:'',
          completeStatus: 0,
          reason: "",
          schedule:"",
          status: 0,
          remark: ""
        },
        classifyList: [
          {label: '重要KPI', value: 0},
          {label: '业务工作', value: 10},
          {label: '费效管理', value: 20},
          {label: '人力资源', value: 30},
          {label: '企业文化', value: 40},
          {label: '个人成长', value: 50},
          {label: '其他新增工作', value: 60},
        ],
        moveClassifyList:[
          {label: '重要KPI', value: 0},
          {label: '业务工作', value: 10},
          {label: '其他工作', value: 60},
        ],
        categoryList: [],
        completeList: [],
        importantList: [
          {label: '否', value: 0},
          {label: '是', value: 1},
        ],
        programList: [
          {"value": "A2000plus"},
          {"value": "A1000plus"},
          {"value": "远程项目"},
        ],
        unHandleList: [],
        handledList: [],
        allChecked: false,
        checkList: [],
        selectAllProgram: false,
        isChecked: false,
        status: 0,
        idList: [],
        summaryData:{},
        weightList:[
          {"value": 5},
          {"value": 10},
          {"value": 15},
          {"value": 20},
          {"value": 25},
          {"value": 30}
        ],
        riskControl:[], //风控
        employee:[], //人才梯队建设
        salary:[], //薪酬管理
        oec:[], //OEC管理
        employ:[], //招聘管理
        train:[], //培训管理
        employeeRelation:[], //员工关系

        orgBuild:[], //组织建设
        culTrain:[], //文化培训
        culIntegral:[], //文化积分
        culSpread:[], //文化传播
        culActivity:[], //文化活动
        culPublicity:[], //文化宣贯
        tableColumn: [],
        tipMsg:'',
        firstLoad:true,
        expandKpiStatus: true,
        expandNormalStatus: true,
        expandCreateStatus: true,
        expandHrStatus:true,
        expandCcStatus:true,
        expandPgStatus:true,
        expandOtherStatus:true,
        cloneKpi:[],
        cloneNormal:[],
        cloneCreate:[],
        cloneHr:[],
        cloneCc:[],
        clonePg:[],
        cloneOther:[],
        model: '1',
        cloneTableData: [],
        row: {},
        timer: null,
        rowIndex: 0,
        that:this,
        editStatus:'',
        saveStatus:'',
        timeoutSave:'',
        timeoutAutoSave:'',
        isCollapse: false,
        showCollapse: false,
        showApprove: false,
        showCompleteApprove: false,
        approveReason:'',
        rejectReason:'',
        approveRow:null,
        pending:false,
        dialogContent:{},
        editData:{},
        downloadUrl: process.env.VUE_APP_PUBLICPATH + "files/年计划导入模版.xlsx",
        autoSaving: false, //是否在自动保存中
        isPreventSave: false, //是否阻止了自动保存
        expandSearchStatus: false,
        expandRowAllFlag: false,
        selecterData: []
      }
    },
    computed: {
      //重要KPI
      kpiLength() { //kpi数据长度 动态增加数据使用
        return this.kpi.length;
      },
      //业务工作
      normalLength() {
        return this.normal.length;
      },
      //费效管理
      createLength() {
        return this.create.length;
      },
      //人力资源
      hrLength() {
        return this.hr.length;
      },
      //企业文化
      ccLength() {
        return this.cc.length;
      },
      //个人成长
      pgLength() {
        return this.pg.length;
      },
      otherLength() {
        return this.other.length;
      },
      tableData() {
        return [{}, ...this.kpi, {}, ...this.normal, {}, ...this.create, {},...this.hr, {},...this.cc, {},...this.pg, {}, ...this.other];
      },
      //风控
      riskControlLength() { //风控数据长度 动态增加数据使用
        return this.riskControl.length;
      },
      //人才梯队建设
      employeeLength() { //人才梯队建设数据长度 动态增加数据使用
        return this.employee.length;
      },
      //薪酬管理
      salaryLength() {
        return this.salary.length;
      },
       //OEC管理
      oecLength() {
        return this.oec.length;
      },
       //招聘管理
      employLength() {
        return this.employ.length;
      },
       //培训管理
      trainLength() {
        return this.train.length;
      },
       //员工关系
      employeeRelationLength() {
        return this.employeeRelation.length;
      },
       //组织建设
      orgBuildLength() {
        return this.orgBuild.length;
      },
       //文化培训
      culTrainLength() {
        return this.culTrain.length;
      },
       //文化积分
      culIntegralLength() {
        return this.culIntegral.length;
      },
       //文化传播
      culSpreadLength() {
        return this.culSpread.length;
      },
       //文化活动
      culActivityLength() {
        return this.culActivity.length;
      },
       //文化宣贯
      culPublicityLength() {
        return this.culPublicity.length;
      },
      tableColumnLength() {
        return this.tableColumn.filter(val => val.visible !== false).length;
      }
    },
    created() {
      this.workId = this.$route.query.id || '';
      this.status = parseInt(this.$route.query.status) || 0;
      this.editStatus = this.$route.query.editStatus || '';
      this.record.workId = this.workId;
      this.msgId = this.$route.query.msgId || null;
      this.childIds = this.$route.query.childIds? this.$route.query.childIds.split(','): null;
      this.from = this.$route.query.from || '';
      this.getCategory();
      this.getWorkItemStatus().then(()=>{
        this.workId && this.getList();
      });
    },
    mounted(){
       this.$nextTick(() => {
        this.tableColumn = this.$refs.year.getColumns();
        if(localStorage.getItem("year_table_herder") && this.editStatus === "edit" && this.model == "1"){
          let cache = JSON.parse(localStorage.getItem("year_table_herder"));
          this.tableColumn.forEach(v => {
            cache.forEach(t => {
              if (v.title == t.title){
                v.visible = t.visible;
              }
            })
          })
          this.$refs.year && this.$refs.year.refreshColumn();
        }else {
          if(this.editStatus === "edit") {
            localStorage.setItem("year_table_herder", JSON.stringify(this.tableColumn));
          }
        }
      });
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    methods: {
      handleCommand(command) {
        this.selecterData = this.$refs.year.getCheckboxRecords().filter(val => val.workId !== undefined);
        if (this.selecterData.length == 0) {
          this.$message.error('请先选择数据');
          return false;
        }
        this.dialogContent = {
          title: '批量操作',
          componentName: 'batchEdit',
          width: '450px',
          command: command
        };
        this.editData.workId = this.workId;
        this.$refs.addSyncDialog.show();
      },
      expandSearch(){
        this.expandSearchStatus = !this.expandSearchStatus;
      },
      copyLast() {
        this.expandAll();
        this.getList();
      },
      collapse(el, column) {
          this.isCollapse = !this.isCollapse;
          if (this.isCollapse) {
            column.forEach(val => {
              if (val.title == "操作" || val.title == "提交状态") {
                val.visible = false;
              }
            });
            el && el.refreshColumn();
            this.setPosition("reset");
          }else {
            column.filter(val => val.title == "操作" || val.title == "提交状态").forEach(val => {
              val.visible = true;
            });
            el && el.refreshColumn();
            setTimeout(() => {
              this.setPosition();
              // this.observerClass();
            }, 50)
          }
      },
      setPosition(reset) {
        this.showCollapse = true;
        if (!document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0]) {
          this.showCollapse = false;
          return false;
        }
        if (!reset && document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth === 0) {
          this.showCollapse = false;
          return false;
        }
        if (reset) {
          document.getElementsByClassName("collapse")[0].style.right = 0;       
        }else {
          try{
            const left = document.getElementsByClassName("vxe-table--fixed-right-wrapper")[0].offsetWidth;
            const height = document.getElementsByClassName('table-content')[0].offsetHeight;
            document.getElementsByClassName("collapse")[0].style.top = (height / 2 - 15)  + "px";
            document.getElementsByClassName("collapse")[0].style.right = left + "px";
          }catch(e){
            throw e;
          }
        }
      },
      observerClass() {
        let targetNode;
        // 选择需要观察变动的节点
          targetNode = document.getElementsByClassName("vxe-table--fixed-right-wrapper")[0];
        // 观察器的配置（需要观察什么变动）
        const config = { attributes: true, attributeFilter: ['class', 'style'],};
        // 当观察到变动时执行的回调函数
        // eslint-disable-next-line no-unused-vars
        const callback = function(mutationsList, observer) {
          // Use traditional 'for loops' for IE 11
          const classList = mutationsList[0].target.classList;
          // console.log(classList);
          if (classList.length == 1) {
            document.getElementsByClassName("collapse")[0].style.display = "none";
          }else {
            document.getElementsByClassName("collapse")[0].style.display = "block";
          }
        };
        // 创建一个观察器实例并传入回调函数
        const observer = new MutationObserver(callback);
        // 以上述配置开始观察目标节点
        observer.observe(targetNode, config);
        // 之后，可停止观察
        // observer.disconnect();
      },
       // 列隐藏展示切换
      columnHideToggle(d){
        let val = this.tableColumn.find(row => row.id == d.id)
        if(val){
          val.visible  = !val.visible
          this.$refs.year && this.$refs.year.refreshColumn();
          if(this.editStatus === "edit" && this.model == "1") {
            localStorage.setItem("year_table_herder", JSON.stringify(this.tableColumn));
          }
          setTimeout(() => {
            this.setPosition(null);
          }, 50);
        }
      },
      saveContent(e) {
        let key = window.event.keyCode ? window.event.keyCode : window.event.which
        if (key === 83 && e.ctrlKey) {
          e.preventDefault();
          this.saveAll();
        }
      },
      saveAll() {
        const arr = this.tableData.filter(val => {
          delete val._XID;
          val.status===null? 0: val.status;
          return val.workId !== undefined && val.status!==35 && val.status!==55 && val.status!==60;
        });
        if(arr.length===0){
         return this.$message.warning('当前没有需要保存的数据');
        }
        this.$ajax.post(this.$api.year.yearWorkDetail.adu, arr).then((res) => {
          if(res.code==0){
            this.$message.success('保存成功');
          }else{
            this.$message.error(res.message);
          }
        });
      },
      async getList() {
        let param = Object.assign({WorkId: this.workId,  WorkItemIds: this.childIds}, this.searchParam, this.page)
        await this.$ajax.get(this.$api.year.yearWorkDetail.list +'?'+ qs.stringify(param,{indices: false})).then((res) => {
          if(res.data){
              if(this.firstLoad&&this.editStatus==="edit"&&res.data.details.length>0&&res.data.details.filter(val => val.workClassify == 30).length===0&&res.data.details.filter(val => val.workClassify == 40).length===0&&this.from!=="message"){
                this.hr =  this.hr.map(p=>{p.workId=this.workId;p.workClassify=30; return p})
                this.cc = this.cc.map(p=>{p.workId=this.workId;p.workClassify=40; return p});
                this.multSave(this.hr.concat(this.cc)).then(()=>{
                  this.getList();
                });    
              }else{
                res.data.details.forEach(item => {item.expandRowFlag = false})
                this.filterTableData(res.data.details);
                this.summaryData=res.data.plan;
                this.status=this.summaryData.status;
                this.setMerge();
              }
              if(res.data.details.length>0){
                this.setMerge();
                this.firstLoad=false;
                setTimeout(() => {
                  this.setPosition();
                },50);
              }
          }
          if (!res.data || res.data.details.length === 0) {
            this.tableData = [{}, {}, {},{}, {}, {}, {}];
            if(this.firstLoad){
              this.firstLoad=false;
              if(res.data.plan.status===0){
                this.multSave(this.hr.concat(this.cc)).then(()=>{
                  this.getList();
                }); 
              }else{
                this.hr=[];
                this.cc=[];
              }
            }else{
              this.hr=[];
              this.cc=[];
              // this.status=null;
            }
          }
        }).catch(()=>{
            this.hr=[];
            this.cc=[];
            this.status=null;
        });
      },
      filterTableData(tableData) {
        this.kpi = tableData.filter(val => val.workClassify == 0);
        this.normal = tableData.filter(val => val.workClassify == 10);
        this.create = tableData.filter(val => val.workClassify == 20);
        this.hr = tableData.length>0? tableData.filter(val => val.workClassify == 30).sort(this.itemSort): this.hr.map(p=>{p.workId=this.workId;p.workClassify=30; return p})
        this.cc = tableData.length>0? tableData.filter(val => val.workClassify == 40).sort(this.itemSort): this.cc.map(p=>{p.workId=this.workId;p.workClassify=40; return p});
        this.pg = tableData.filter(val => val.workClassify == 50);
        this.other = tableData.filter(val => val.workClassify == 60);
        this.calcHrWeight(this.hr);
        this.calcCCheight(this.cc);
      },
      calcCCheight(data) {
        this.orgBuild=data.filter(t=>t.workItemCategory==="组织建设");
        this.culTrain=data.filter(t=>t.workItemCategory==="文化培训");
        this.culIntegral=data.filter(t=>t.workItemCategory==="文化积分");
        this.culSpread=data.filter(t=>t.workItemCategory==="文化传播");
        this.culActivity=data.filter(t=>t.workItemCategory==="文化活动");
        this.culPublicity=data.filter(t=>t.workItemCategory==="文化宣贯");
      },
      calcHrWeight(data){
        this.riskControl=data.filter(t=>t.workItemCategory==="风控");
        this.riskControl.forEach(item=>{
          item.weightTemp=this.riskControl.map(p=>p.weight).reduce((prev,cur)=>prev+cur);
        });
        this.employee=data.filter(t=>t.workItemCategory==="人才梯队建设");
        this.employee.forEach(item=>{
          item.weightTemp=this.employee.map(p=>p.weight).reduce((prev,cur)=>prev+cur);
        });
        this.salary=data.filter(t=>t.workItemCategory==="薪酬管理");
        this.salary.forEach(item=>{
          item.weightTemp=this.salary.map(p=>p.weight).reduce((prev,cur)=>prev+cur);
        });
        this.oec=data.filter(t=>t.workItemCategory==="OEC管理");
        this.oec.forEach(item=>{
          item.weightTemp=this.oec.map(p=>p.weight).reduce((prev,cur)=>prev+cur);
        });
        this.employ=data.filter(t=>t.workItemCategory==="招聘管理");
        this.employ.forEach(item=>{
          item.weightTemp=this.employ.map(p=>p.weight).reduce((prev,cur)=>prev+cur);
        });
        this.train=data.filter(t=>t.workItemCategory==="培训管理");
        this.train.forEach(item=>{
          item.weightTemp=this.train.map(p=>p.weight).reduce((prev,cur)=>prev+cur);
        });
        this.employeeRelation=data.filter(t=>t.workItemCategory==="员工关系");
        this.employeeRelation.forEach(item=>{
          item.weightTemp=this.employeeRelation.map(p=>p.weight).reduce((prev,cur)=>prev+cur);
        });
      },
      selectSingle(row) {
        this.$refs.year.toggleCheckboxRow(row);
      },
      async addKpi() {
        if (!this.expandKpiStatus) {
          this.expandKpiStatus = !this.expandKpiStatus;
          this.kpi = _.cloneDeep(this.cloneKpi);
          this.cloneKpi=[];
        }
        if (this.kpiLength >= this.$config.workItemLength.year.kpi) {
          this.$message.error(`最多可添加${this.$config.workItemLength.year.kpi}条数据`);
          return false;
        }
        const $table = this.$refs.year;
        this.record.workItemNo = (this.kpiLength + 1).toString();
        this.kpi.push(_.cloneDeep(this.record));
        await $table.setActiveRow(this.tableData[this.kpiLength]);
      },
      async addNormal() {
        if (!this.expandNormalStatus) {
          this.expandNormalStatus = !this.expandNormalStatus;
          this.normal = _.cloneDeep(this.cloneNormal);
          this.cloneNormal=[];
        }
        if (this.normalLength >= this.$config.workItemLength.year.normal) {
          this.$message.error(`最多可添加${this.$config.workItemLength.year.normal}条数据`);
          return false;
        }
        const $table = this.$refs.year;
        this.record.workItemNo = (this.normalLength + 1).toString();
        let normalItem = _.cloneDeep(this.record);
        normalItem.workClassify = 10;
        this.normal.push(normalItem);
        await $table.setActiveRow(this.tableData[this.kpiLength + 1 + this.normalLength]);
      },
      async addCreate() {
        if (!this.expandCreateStatus) {
          this.expandCreateStatus = !this.expandCreateStatus;
          this.create = _.cloneDeep(this.cloneCreate);
          this.cloneCreate=[];
        }
        if (this.createLength >= this.$config.workItemLength.year.create) {
          this.$message.error(`最多可添加${this.$config.workItemLength.year.create}条数据`);
          return false;
        }
        const $table = this.$refs.year;
        this.record.workItemNo = (this.createLength + 1).toString();
        let createItem = _.cloneDeep(this.record);
        createItem.workClassify = 20;
        this.create.push(createItem);
        await $table.setActiveRow(this.tableData[this.kpiLength + 2 + this.normalLength + this.createLength]);
      },
      async addHr() {
        const $table = this.$refs.year;
        let hrItem = _.cloneDeep(this.record);
        hrItem.workClassify = 30;
        this.hr.push(hrItem);
        await $table.setActiveRow(this.tableData[this.kpiLength + 3 + this.normalLength + this.createLength + this.hrLength]);
      },
      async addCc() {
        const $table = this.$refs.year;
        let ccItem = _.cloneDeep(this.record);
        ccItem.workClassify = 40;
        this.cc.push(ccItem);
        await $table.setActiveRow(this.tableData[this.kpiLength + 4 + this.normalLength + this.createLength + this.hrLength + this.ccLength]);
      },
      async addPg() {
        if (!this.expandPgStatus) {
            this.expandPgStatus = !this.expandPgStatus;
            this.pg = _.cloneDeep(this.clonePg);
            this.clonePg=[];
        }
        if (this.pgLength >= this.$config.workItemLength.year.pg) {
          this.$message.error(`最多可添加${this.$config.workItemLength.year.pg}条数据`);
          return false;
        }
        const $table = this.$refs.year;
        this.record.workItemNo = (this.pgLength + 1).toString();
        let pgItem = _.cloneDeep(this.record);
        pgItem.workClassify = 50;
        this.pg.push(pgItem);
        await $table.setActiveRow(this.tableData[this.kpiLength + 5 + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength]);
      },
      async addOther() {
       if (!this.expandOtherStatus) {
          this.expandOtherStatus = !this.expandOtherStatus;
          this.other = _.cloneDeep(this.cloneOther);
          this.cloneOther=[];
       }
        const $table = this.$refs.year;
        this.record.workItemNo = (this.otherLength + 1).toString();
        let otherItem = _.cloneDeep(this.record);
        otherItem.workClassify = 60;
        this.other.push(otherItem);
        await $table.setActiveRow(this.tableData[this.kpiLength + 6 + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + this.otherLength]);
      },
      setRowClass({rowIndex}) {
        if (rowIndex == 0 || rowIndex == this.kpiLength + 1 || rowIndex == this.kpiLength + this.normalLength + 2 || rowIndex == this.kpiLength + this.normalLength + this.createLength + 3 || rowIndex == this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4 || rowIndex == this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + 5 || rowIndex == this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6) {
          return 'main-row';
        }
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format)
      },
      async save(row, index) {
        if (this.autoSaving) {
          this.isPreventSave = true;
        }else{
          this.pending=true,
          row.status=row.status===null? 0: row.status;
          await this.$ajax.post(this.$api.year.yearWorkDetail.adu,  [this.cloneTableData[index]],{noLoading:true}).then((res) => {
            const item = res.data instanceof Array? res.data[0]: {};
            item.expandRowFlag = this.cloneTableData[index].expandRowFlag;
            if (item.workClassify === 0) {
              if (this.expandKpiStatus) {
                this.kpi.splice(index - 1, 1, item);
              }else{
                this.cloneKpi.splice(index - 1, 1, item);
              }
            } else if (item.workClassify === 10) {
              if(this.expandNormalStatus){
                this.normal.splice(index - this.kpiLength - 2, 1, item);
              }else{
                this.cloneNormal.splice(index - this.kpiLength - 2, 1, item);
              }
            } else if (item.workClassify === 20) {
              if(this.expandCreateStatus){
                this.create.splice(index - this.kpiLength - this.normalLength - 3, 1, item);
              }else{
                this.cloneCreate.splice(index - this.kpiLength - this.normalLength - 3, 1, item);
              }
            } else if (item.workClassify === 30) {
              if(this.expandHrStatus){
                this.hr.splice(index - this.kpiLength - this.normalLength - this.createLength - 4, 1, item);
              }else{
                this.cloneHr.splice(index - this.kpiLength - this.normalLength - this.createLength - 4, 1, item);
              }
            } else if (item.workClassify === 40) {
              if(this.expandCcStatus){
                this.cc.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - 5, 1, item);
              }else{
                this.cloneCc.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - 5, 1, item);
              }
            } else if (item.workClassify === 50) {
              if(this.expandPgStatus){
                this.pg.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - this.ccLength - 6, 1, item);
              }else{
                this.clonePg.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - this.ccLength - 6, 1, item);
              }
            } else if(item.workClassify === 60) {
              if(this.expandOtherStatus){
                this.other.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - this.ccLength - this.pgLength - 7, 1, item);
              }else{
                this.cloneOther.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - this.ccLength - this.pgLength - 7, 1, item);
              }
            }
            this.filterTableData(this.tableData);
            this.saveStatus="已保存";
            this.timeoutSave&&clearTimeout(timeoutSave);
            const timeoutSave=setTimeout(()=>{
              this.saveStatus="";
            },1000,this);
            clearInterval(this.timer);
            this.$nextTick(() => {
              this.setMerge();
            });
          }).finally(()=>{
            this.pending = false;
          });
        } 
      },
      async saveAuto(row, index) {
        this.autoSaving = true;
        const weight=this.cloneTableData[index].weight;
        this.cloneTableData[index].weight=weight? weight: 1;
        await this.$ajax.post(this.$api.year.yearWorkDetail.adu, [this.cloneTableData[index]],{noLoading:true}).then((res) => {
          const item = res.data&&res.data[0];
          this.row = item;
          this.cloneTableData.splice(index, 1, item);
          this.saveStatus="已保存";
          this.timeoutAutoSave&&clearTimeout(timeoutAutoSave);
          const timeoutAutoSave=setTimeout(()=>{
            this.saveStatus="";
          },1000,this);
          this.autoSaving = false;
          if(this.isPreventSave) {
            this.save(row, index);
          }
        }).catch(() => {
          this.autoSaving = false;
        });
      },
      copyPreviousYearPlan(){
        this.dialogContent = {
          title: '复制年计划',
          componentName: 'addSync',
          width: "950px"
        }
        this.editData.workId=this.workId;
        this.editData.year=this.summaryData.year? this.summaryData.year-1: 0;
        this.$refs.addSyncDialog.show()
      },
      editClosed({row, rowIndex}) {
        this.enabled=true;
        this.enabledFullTarget=true;
        this.enabledHalfTarget=true;
        this.enabledWorkItemCategory=true;
        this.enabledExcep=true;
        this.enabledFhs = true;
        this.enabledFs = true;
        this.enabledFinishFullTarget=true;
        clearInterval(this.timer);
        if (rowIndex !== -1) {
          if ((this.status === 0 && this.editStatus==="edit") || (row.status === 10 && this.editStatus==="approve") ||(this.editStatus==="edit" && (row.status === 0 || row.status === 20 || row.status === 30 || row.status === 40 || row.status === 50 || row.status === 70))) {
            if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = false;
            this.$refs.year.updateData(this.tableData);
            this.save(this.tableData[rowIndex], rowIndex);
          }
        }
      },
      activeRow({row, rowIndex}) {
        this.row = row;
        this.rowIndex = rowIndex;
        if ((this.row.status == 0 || this.row.status == 30) && this.editStatus == 'edit' && this.row.finishFullTarget == '') {
          this.$set(row, 'finishFullTarget', row.fullTarget);
        }
        clearInterval(this.timer);
        if ((this.status === 0 || this.status === 30 && this.editStatus==="edit") || (this.status === 10 && this.editStatus==="approve")||(this.editStatus==="edit"&&(row.status === 20 || row.status === 40 || row.status === 50 || row.status === 70))) {
          this.timer = setInterval(() => {
            if(!row.id) this.blurIndex=rowIndex;
            this.saveAuto(row, rowIndex);
          }, 10000)
        }
      },
      async copyData(row, index) {
        const $table = this.$refs.year;
        const item = _.cloneDeep(row);
        delete item._XID;
        delete item.id;
        item.status = 0;
        if (index <= this.kpiLength) {
          if (this.kpiLength >= this.$config.workItemLength.year.kpi) {
            this.$message.error(`最多可添加${this.$config.workItemLength.year.kpi}条数据`);
            return false;
          }
          this.kpi.push(item);
          await $table.setActiveRow(this.tableData[this.kpiLength]);
        } else if (index > this.kpiLength + 1 && index <= this.normalLength + this.kpiLength + 2) {
          if (this.normalLength >= this.$config.workItemLength.year.normal) {
            this.$message.error(`最多可添加${this.$config.workItemLength.year.normal}条数据`);
            return false;
          }
          this.normal.push(item);
          await $table.setActiveRow(this.tableData[this.kpiLength + 1 + this.normalLength]);
        } else if (index > this.normalLength + this.kpiLength + 2 && index <= this.normalLength + this.kpiLength + this.createLength + 3) {
          if (this.createLength >= this.$config.workItemLength.year.create) {
            this.$message.error(`最多可添加${this.$config.workItemLength.year.create}条数据`);
            return false;
          }
          this.create.push(item);
          await $table.setActiveRow(this.tableData[this.kpiLength + 2 + this.normalLength + this.createLength]);
        } else if (index > this.normalLength + this.kpiLength + this.createLength + 3 && index <= this.normalLength + this.kpiLength + this.createLength + this.hrLength + 4) {
          this.hr.push(item);
          await $table.setActiveRow(this.tableData[this.kpiLength + 3 + this.normalLength + this.createLength + this.hrLength]);
        } else if (index > this.normalLength + this.kpiLength + this.createLength + this.hrLength + 4 && index <= this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5) {
          this.cc.push(item);
          await $table.setActiveRow(this.tableData[this.kpiLength + 4 + this.normalLength + this.createLength + this.hrLength + this.ccLength]);
        } else if (index > this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5 && index <= this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6) {
          if (this.pgLength >= this.$config.workItemLength.year.pg) {
            this.$message.error(`最多可添加${this.$config.workItemLength.year.pg}条数据`);
            return false;
          }
          this.pg.push(item);
          await $table.setActiveRow(this.tableData[this.kpiLength + 5 + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength]);
        } else {
          this.other.push(item);
          await $table.setActiveRow(this.tableData[this.kpiLength + 6 + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + this.otherLength]);
        }
      },
      deleteData(row, index) {
        if (row.id) {
          this.$ajax.delete(this.$api.year.yearWorkDetail.adu + '/' + row.id).then(() => {
            this.row = {};
            const item = row;
            if (item.workClassify === 0) {
              _.remove(this.kpi, t => t.id == row.id);
              this.kpi.splice(0,0);
            } else if (item.workClassify === 10) {
              _.remove(this.normal, t => t.id == row.id);
              this.normal.splice(0,0);
            } else if (item.workClassify === 20) {
              _.remove(this.create, t => t.id == row.id);
              this.create.splice(0,0);
            } else if (item.workClassify === 30) {
              _.remove(this.hr, t => t.id == row.id);
              this.hr.splice(0,0);
            } else if (item.workClassify === 40) {
              _.remove(this.cc, t => t.id == row.id);
              this.cc.splice(0,0);
            } else if (item.workClassify === 50) {
             _.remove(this.pg, t => t.id == row.id);
              this.pg.splice(0,0);
            } else if(item.workClassify === 60) {
               _.remove(this.other, t => t.id == row.id);
              this.other.splice(0,0);
            }
            // if (index <= this.kpiLength) {
            //   this.kpi.splice(index - 1, 1);
            // } else if (index > this.kpiLength + 1 && index <= this.normalLength + this.kpiLength + 2) {
            //   this.normal.splice(index - this.kpiLength - 2, 1);
            // } else if (index > this.normalLength + this.kpiLength + 2 && index <= this.normalLength + this.kpiLength + this.createLength + 3) {
            //   this.create.splice(index - this.kpiLength - this.normalLength - 3, 1);
            // } else if (index > this.normalLength + this.kpiLength + this.createLength + 3 && index <= this.normalLength + this.kpiLength + this.createLength + this.hrLength + 4) {
            //   this.hr.splice(index - this.kpiLength - this.normalLength - this.createLength - 4, 1);
            // }else if (index > this.normalLength + this.kpiLength + this.createLength + this.hrLength + 4 && index <= this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5) {
            //   this.cc.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - 5, 1);
            // }else if (index > this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5 && index <= this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6) {
            //   this.pg.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - this.ccLength - 6, 1);
            // }else {
            //   this.other.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - this.ccLength - this.pgLength - 7, 1);
            // }
            clearInterval(this.timer);
            this.$message.success('删除成功');
          });
        }else{
          if (index <= this.kpiLength) {
            this.kpi.splice(index - 1, 1);
          } else if (index > this.kpiLength + 1 && index <= this.normalLength + this.kpiLength + 2) {
            this.normal.splice(index - this.kpiLength - 2, 1);
          } else if (index > this.normalLength + this.kpiLength + 2 && index <= this.normalLength + this.kpiLength + this.createLength + 3) {
            this.create.splice(index - this.kpiLength - this.normalLength - 3, 1);
          } else if (index > this.normalLength + this.kpiLength + this.createLength + 3 && index <= this.normalLength + this.kpiLength + this.createLength + this.hrLength + 4) {
            this.hr.splice(index - this.kpiLength - this.normalLength - this.createLength - 4, 1);
          }else if (index > this.normalLength + this.kpiLength + this.createLength + this.hrLength + 4 && index <= this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5) {
            this.cc.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - 5, 1);
          }else if (index > this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5 && index <= this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6) {
            this.pg.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - this.ccLength - 6, 1);
          }else {
            this.other.splice(index - this.kpiLength - this.normalLength - this.createLength - this.hrLength - this.ccLength - this.pgLength - 7, 1);
          }
          clearInterval(this.timer);
          this.$message.success('删除成功');
        }
      },
      submit(){
        const validateObj={};
        this.showSubmit=false;
        this.expandAll();
        this.setMerge();
        this.changeModel("1", "submit");
        this.model = "1";
        this.$nextTick(async ()=>{
          let check = this.$refs.year.getCheckboxRecords();
            const checkData = check.filter(val => val.workId !== undefined);
            const data=this.tableData.filter(t=>typeof t.id!=='undefined');
          if(data.length&&data.filter(t=>t.source===0).every(t=>t.status==0||t.status==30)){
            validateObj.value=data.filter(t=>t.source===0);
          }else{
              if(checkData.length){ 
                validateObj.value=checkData;
              }else{
                validateObj.value=data;
              }
          }
            const $table = this.$refs.year
            const errMap = await $table.validate(validateObj.value).catch(errMap => errMap)
            if(errMap) {
                const msgList = []
                Object.values(errMap).forEach(errList => {
                  errList.forEach(params => {
                    const { rowIndex, column, rules } = params
                    rules.forEach(rule => {
                      // msgList.push(`第 ${rowIndex + 1} 行 ${column.title} 校验错误：${rule.message}`)
                      msgList.push(`${rule.message}`)
                    })
                  })
                })
                this.$message({
                  type: 'error',
                  message: msgList.join()
                })
            }else{
            if(data.length===0){
                return this.$message.success('计划内容未填写...');
            }else if(data.filter(t=>t.source===0).length && data.filter(t=>t.source===0).every(t=>t.status==10)){
              console.log([].every(t=>t.status==10));
              return this.$message.warning('计划已提交');   
            }else if(data.filter(t=>t.source===0).length && data.filter(t=>t.source===0).every(t=>t.status==0||t.status==30)){
                this.$ajax.put(this.$api.year.yearWorkDetail.submit, {workId: this.workId, status: 10, msgId: this.msgId}, { headers: { 'Content-Type': 'application/json;charset=UTF-8;' } }).then((res) => {
                  if(res.code==0){
                    this.$message.success('提交成功');
                    this.getList();
                  }else{
                    this.$message.error(res.message);
                  }
                })
            }else if(checkData.length===0){
              if(data.every(t=>t.status==35||t.status==55)){
                return this.$message.warning('总结已提交');   
              }else if(this.childIds){
                  this.idList = data.map(val => {
                    const {id} = val;
                    return {id: id, workId: this.workId};
                  });
                if(data.every(t=>t.status==20||t.status==50)){     
                    const list = this.idList.map(val => {
                      return {...val, status: 35, msgId: this.msgId};
                    })  
                    this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                          this.$message.success('提交成功');
                          this.getList();
                    });
                  }else if(data.every(t=>t.status==40||t.status==70)){
                    const list = this.idList.map(val => {
                      return {...val, status: 55, msgId: this.msgId};
                    })  
                    this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                          this.$message.success('提交成功');
                          this.getList();
                    });
                  }else {
                    return this.$message.error('任务状态不一致...');
                  }
              }else{
              this.idList = data.map(val => {
                const {id} = val;
                return {id: id, workId: this.workId};
              });
              if(data.every(t=>t.status==20||t.status==50)){
                  const list = this.idList.map(val => {
                      return {...val, status: 35, msgId: this.msgId};
                  })        
                  this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then((res) => {
                      if(res.code==0){
                        this.$message.success('提交成功');
                        this.getList();
                      }else{
                        this.$message.error(res.message);
                      }
                  });
                }else if(data.every(t=>t.status==40||t.status==70)){
                  const list = this.idList.map(val => {
                      return {...val, status: 55, msgId: this.msgId};
                  }) 
                  this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then((res) => {
                      if(res.code==0){
                        this.$message.success('提交成功');
                        this.getList();
                      }else{
                        this.$message.error(res.message);
                      }
                  });
                }else if(data.every(t=>t.status===60)){
                    this.$message.warning('任务已完成，您无须重复提交。');
              }else {
                  return this.$message.error('任务状态不一致...');
                }
              }
            }else{
              if(checkData.every(t=>t.status==35||t.status==55)){
                return this.$message.warning('总结已提交');   
              }
            else if(checkData.every(t=>t.status==20||t.status==50)){       
                let data = check.filter(val => val.workId !== undefined);
                  this.idList = data.map(val => {
                    const {id} = val;
                    return {id: id, workId: this.workId};
                  });
                const list = this.idList.map(val => {
                    return {...val, status: 35, msgId: this.msgId};
                  })
                this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then((res) => {
                    if(res.code==0){
                      this.$message.success('提交成功');
                      this.getList();
                    }else{
                      this.$message.error(res.message);
                    }
                });
              }else if(checkData.every(t=>t.status==40||t.status==70)){
                let data = check.filter(val => val.workId !== undefined);
                  this.idList = data.map(val => {
                    const {id} = val;
                    return {id: id, workId: this.workId};
                  });
                const list = this.idList.map(val => {
                    return {...val, status: 55, msgId: this.msgId};
                  })
                this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then((res) => {
                    if(res.code==0){
                      this.$message.success('提交成功');
                      this.getList();
                    }else{
                      this.$message.error(res.message);
                    }
                });
              }else if(checkData.every(t=>t.status===60)){
                  this.$message.warning('任务已完成，您无须重复提交。');
              }else {
                return this.$message.error('任务状态不一致...');
              }
            }
          }
        });
      },
      updateStatus(doWhat) {
        if(doWhat==="access"){
          this.showApprove=false;
        }else{
          this.showCompleteApprove=false;
           if (typeof(this.rejectReason)==="undefined" || this.rejectReason===null || this.rejectReason.split(" ").join("").length === 0 || this.rejectReason.replace(/\s+/g,"").length===0) {
            this.$message.error("必须填写驳回原因");
            return false;
           }
        }
        let check = this.$refs.year.getCheckboxRecords();
        const checkData = check.filter(val => val.workId !== undefined);
        const data=this.tableData.filter(t=>typeof t.id!=='undefined');
        if (data.filter(t=>t.source===0).length&&data.filter(t=>t.source===0).every(t=>t.status==10)) {
          //员工提交工作项目 待审批状态
          if (doWhat == "access") {
            this.$ajax.put(this.$api.year.yearWorkDetail.submit, {workId: this.workId, status: 20, msgId: this.msgId, approveReason: this.approveReason}).then(() => {
              this.$message.success('审批成功');
              this.editStatus= '';
              this.getList();
            });
          } else {
            this.$ajax.put(this.$api.year.yearWorkDetail.submit, {workId: this.workId, status: 30, msgId: this.msgId, approveReason: this.rejectReason}).then(() => {
              this.$message.success('审批成功');
              this.editStatus= '';
              this.getList();
            });
          }
        }
        else if(checkData.length===0){
        if (this.approveRow) {
            const obj={};
            if(doWhat === "access"){
               if(this.approveRow.status===35){
                  obj.status=40;
               }else{
                  obj.status=60;
               }
            }else{
               if(this.approveRow.status===35){
                  obj.status=50;
               }else{
                  obj.status=70;
               }
            }
            const paramArr= [{
              id: this.approveRow.id,
              status: obj.status,
              workId: this.workId,
              msgId: this.msgId,
              approveReason: doWhat === "access"? this.approveReason:this.rejectReason
            }]
            this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus,paramArr).then((res) => {
              if(res.code==0){
                this.$message.success('审批成功');
                this.getList().then(()=>{
                  const data=this.tableData.filter(t=>typeof t.id!=='undefined');
                  this.editStatus= this.judgeCompleteStatus(data)? "": 'approve';
                });
                if (obj.status === 40 || obj.status === 60) {
                  this.toWorkscorePage({status: obj.status});
                }
              }
            });
          }else if(this.childIds){
              if (data.some(t=>t.status==35)) {
                this.idList = data.filter(t=>t.status===35).map(val => {
                  const {id} = val;
                  return {id: id, workId: this.workId};
                });
                if (doWhat == 'access') {
                  //工作状态变更已通过状态
                  const list = this.idList.map(val => {
                    return {...val, status: 40, msgId: this.msgId, approveReason: this.approveReason};
                  })
                  this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                    this.$message.success('审批成功');
                    this.editStatus= '';
                    this.getList();
                    this.toWorkscorePage({status: 40});
                  });
                }else {
                  //工作状态变更已驳回状态
                  const list = this.idList.map(val => {
                    return {...val, status: 50, msgId: this.msgId, approveReason: this.rejectReason};
                  })
                  this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                    this.$message.success('审批成功');
                    this.editStatus= '';
                    this.getList();
                  });
                }
            }else if (data.some(t=>t.status==55)) {
                this.idList = data.filter(t=>t.status===55).map(val => {
                  const {id} = val;
                  return {id: id, workId: this.workId};
                });
              if (doWhat == 'access') {
                //工作状态变更已通过状态
                const list = this.idList.map(val => {
                  return {...val, status: 60, msgId: this.msgId, approveReason: this.approveReason};
                })
                this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                  this.$message.success('审批成功');
                  this.editStatus= ''
                  this.getList();
                  this.toWorkscorePage({status: 60});
                });
              }else {
                //工作状态变更已驳回状态
                const list = this.idList.map(val => {
                  return {...val, status: 70, msgId: this.msgId, approveReason: this.rejectReason};
                })
                this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                  this.$message.success('审批成功');
                  this.editStatus= '';
                  this.getList();
                });
              }
            }else {
              this.$message.error("当前状态不能再被审批");
            }
          }else{
            if (data.every(t=>t.status==35)) {
              if (doWhat == 'access') {
                //工作状态变更已通过状态
                this.$ajax.put(this.$api.year.yearWorkDetail.updateAllStatus, {workId: this.workId, status: 40, msgId: this.msgId, approveReason: this.approveReason}).then(() => {
                  this.$message.success('审批成功');
                  this.editStatus= '';
                  this.getList();
                  this.toWorkscorePage({status: 40});
                });
              }else {
                //工作状态变更已驳回状态
                this.$ajax.put(this.$api.year.yearWorkDetail.updateAllStatus, {workId: this.workId, status: 50, msgId: this.msgId, approveReason: this.rejectReason}).then(() => {
                  this.$message.success('审批成功');
                  this.editStatus= '';
                  this.getList();
                });
              }
            }else if (data.every(t=>t.status==55)) {
              if (doWhat == 'access') {
                //工作状态变更已通过状态
                this.$ajax.put(this.$api.year.yearWorkDetail.updateAllStatus, {workId: this.workId, status: 60, msgId: this.msgId, approveReason: this.approveReason}).then(() => {
                  this.$message.success('审批成功');
                  this.editStatus= '';
                  this.getList();
                  this.toWorkscorePage({status: 60});
                });
              }else {
                //工作状态变更已驳回状态
                this.$ajax.put(this.$api.year.yearWorkDetail.updateAllStatus, {workId: this.workId, status: 70, msgId: this.msgId, approveReason: this.rejectReason}).then(() => {
                  this.$message.success('审批成功');
                  this.editStatus= '';
                  this.getList();
                });
              }
            }else if (data.some(t=>t.status==35)) {
                this.idList = data.filter(t=>t.status===35).map(val => {
                  const {id} = val;
                  return {id: id, workId: this.workId};
                });
                if (doWhat == 'access') {
                  //工作状态变更已通过状态
                  const list = this.idList.map(val => {
                    return {...val, status: 40, msgId: this.msgId, approveReason: this.approveReason};
                  })
                  this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                    this.$message.success('审批成功');
                    this.editStatus= '';
                    this.getList();
                    this.toWorkscorePage({status: 40});
                  });
                }else {
                  //工作状态变更已驳回状态
                  const list = this.idList.map(val => {
                    return {...val, status: 50, msgId: this.msgId, approveReason: this.rejectReason};
                  })
                  this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                    this.$message.success('审批成功');
                    this.editStatus= '';
                    this.getList();
                  });
                }
            }else if (data.some(t=>t.status==55)) {
                this.idList = data.filter(t=>t.status===55).map(val => {
                  const {id} = val;
                  return {id: id, workId: this.workId};
                });
              if (doWhat == 'access') {
                //工作状态变更已通过状态
                const list = this.idList.map(val => {
                  return {...val, status: 60, msgId: this.msgId, approveReason: this.approveReason};
                })
                this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                  this.$message.success('审批成功');
                  this.editStatus= '';
                  this.getList();
                  this.toWorkscorePage({status: 60});
                });
              }else {
                //工作状态变更已驳回状态
                const list = this.idList.map(val => {
                  return {...val, status: 70, msgId: this.msgId, approveReason: this.rejectReason};
                })
                this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                  this.$message.success('审批成功');
                  this.editStatus= '';
                  this.getList();
                });
              }
            }else {
              this.$message.error("当前状态不能再被审批");
            }
          }
        }else{
        if (checkData.every(t=>t.status === 35)) {
            let data = check.filter(val => val.workId !== undefined);
            this.idList = data.map(val => {
              const {id} = val;
              return {id: id, workId: this.workId};
            });
            if (doWhat == 'access') {
              const list = this.idList.map(val => {
                return {...val, status: 40, msgId: this.msgId, approveReason: this.approveReason};
              })
              //工作状态变更待审批状态
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                this.getList().then(()=>{
                  const data=this.tableData.filter(t=>typeof t.id!=='undefined');
                  this.editStatus= this.judgeCompleteStatus(data)? "": 'approve';
                });
                this.toWorkscorePage({status: 40});
              });
            }else {
              const list = this.idList.map(val => {
                return {...val, status: 50, msgId: this.msgId, approveReason: this.rejectReason};
              })
              //工作状态变更待审批状态
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                this.getList().then(()=>{
                  const data=this.tableData.filter(t=>typeof t.id!=='undefined');
                  this.editStatus= this.judgeCompleteStatus(data)? "": 'approve';
                });
              });
            }
          }else if (checkData.every(t=>t.status === 55)) {
            let data = check.filter(val => val.workId !== undefined);
            this.idList = data.map(val => {
              const {id} = val;
              return {id: id, workId: this.workId};
            });
            if (doWhat == 'access') {
              const list = this.idList.map(val => {
                return {...val, status: 60, msgId: this.msgId, approveReason: this.approveReason};
              })
              //工作状态变更待审批状态
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                this.getList().then(()=>{
                  const data=this.tableData.filter(t=>typeof t.id!=='undefined');
                  this.editStatus= this.judgeCompleteStatus(data)? "": 'approve';
                });
                this.toWorkscorePage({status: 60});
              });
            }else {
              const list = this.idList.map(val => {
                return {...val, status: 70, msgId: this.msgId, approveReason: this.rejectReason};
              })
              //工作状态变更待审批状态
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                 this.getList().then(()=>{
                  const data=this.tableData.filter(t=>typeof t.id!=='undefined');
                  this.editStatus= this.judgeCompleteStatus(data)? "": 'approve';
                });
              });
            }
          }else {
             this.$message.error("当前状态不能再被审批");
          }
        }
      },
      judgeCompleteStatus(data){
         if(data.filter(t=>t.status===55||t.status===35||t.status===10).length){
            return false;
         }
         return true;
      },
      editActived({row,rowIndex}) {
         //审批状态
        if (this.editStatus == "approve") {
          if(row.status===0){
            if(rowIndex>this.normalLength + this.kpiLength + this.createLength + 3 && rowIndex <=this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5){
              this.enabledExcep=false;
              this.enabledFullTarget=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledFinishFullTarget=false;
            }else{
              this.enabledExcep=true;
              this.enabledFullTarget=true;
              this.enabledHalfTarget=true;
              this.enabledWorkItemCategory=true;
              this.enabledFinishFullTarget=true;
            }
            this.enabled = true;
            this.enabledHalfTarget=true;
            this.enabledFhs = false;
            this.enabledFs = false;
          }else if(row.status === 10){
              this.enabled=true;
              this.enabledHalfTarget=true;
              this.enabledWorkItemCategory=true;
              this.enabledExcep=true;
              this.enabledFhs = false;
              this.enabledFs = false;
              this.enabledFinishFullTarget=true;
          }else if(row.status === 35){
              this.enabled=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledExcep=false;
              this.enabledFhs = false;
              this.enabledFs = false;
              this.enabledFinishFullTarget=false;
              this.enabledFullTarget=false;
          }else if(row.status === 55){
              this.enabled=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledExcep=false;
              this.enabledFhs = false;
              this.enabledFs = false;
              this.enabledFinishFullTarget=false;
          }else if(row.status === 60){
              this.enabled=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledExcep=false;
              this.enabledFhs = false;
              this.enabledFs = false;
              this.enabledFinishFullTarget=false;
          }else if(row.status === 30){
              if(rowIndex>this.normalLength + this.kpiLength + this.createLength + 3 && rowIndex <=this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5){
              this.enabledExcep=false;
              this.enabledFullTarget=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledFinishFullTarget=false;
            }else{
              this.enabledExcep=true;
              this.enabledFullTarget=true;
              this.enabledHalfTarget=true;
              this.enabledWorkItemCategory=true;
              this.enabledFinishFullTarget=true;
            }
            this.enabled=true;
            this.enabledFhs=false;
            this.enabledFs=false;
          }else if(row.status === 20){
            if(row.source===0){
              this.enabled = false;
              this.enabledFullTarget=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledExcep=false;
              this.enabledFhs=false;
              this.enabledFs=false;
              this.enabledFinishFullTarget=false;
            }else{
              this.enabled = false;
              this.enabledHalfTarget=true;
              this.enabledWorkItemCategory=true;
              this.enabledExcep=false;
              this.enabledFhs=false;
              this.enabledFs = false;
              this.enabledFinishFullTarget=false;
            }
          }else if(row.status===50){
            this.enabled = false;
            this.enabledFullTarget=false;
            this.enabledHalfTarget=false;
            this.enabledWorkItemCategory=false;
            this.enabledExcep=false;
            this.enabledFhs=false;
            this.enabledFs = false;
            this.enabledFinishFullTarget=false;
          }else if(row.status === 40 || row.status===70){
            this.enabled = false;
            this.enabledFullTarget=false;
            this.enabledHalfTarget=false;
            this.enabledWorkItemCategory=false;
            this.enabledExcep=false;
            this.enabledFhs=false;
            this.enabledFs=false;
            this.enabledFinishFullTarget=false;
          }else{
            if(rowIndex>this.normalLength + this.kpiLength + this.createLength + 3 && rowIndex <=this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5){
              this.enabledExcep=false;
              this.enabledFullTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledFinishFullTarget=false;
            }else{
              this.enabledExcep=true;
              this.enabledFullTarget=true;
              this.enabledWorkItemCategory=true;
              this.enabledFinishFullTarget=true;
            }
            this.enabled=true;
            this.enabledHalfTarget=true;
            this.enabledFhs=false;
            this.enabledFs=false;
          }
        }else if (this.editStatus == "edit") {
          //编辑状态
          if(row.status===0){
            if(rowIndex>this.normalLength + this.kpiLength + this.createLength + 3 && rowIndex <=this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5){
              this.enabledExcep=false;
              this.enabledFullTarget=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledFinishFullTarget=false;
            }else{
              this.enabledHalfTarget=true;
              this.enabledExcep=true;
              this.enabledFullTarget=true;
              this.enabledWorkItemCategory=true;
              this.enabledFinishFullTarget=true;
            }
            this.enabled = true;
            this.enabledFhs = false;
            this.enabledFs = false;
          }else if(row.status === 10){
              this.enabled=false;
              this.enabledFullTarget=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledExcep=false;
              this.enabledFhs = false;
              this.enabledFs = false;
              this.enabledFinishFullTarget=false;
          }else if(row.status === 35){
              this.enabled=false;
              this.enabledFullTarget=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledExcep=false;
              this.enabledFhs = false;
              this.enabledFs = false;
              this.enabledFinishFullTarget=false;
          }else if(row.status === 55){
              this.enabled=false;
              this.enabledFullTarget=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledExcep=false;
              this.enabledFhs = false;
              this.enabledFs = false;
              this.enabledFinishFullTarget=false;
          }else if(row.status === 60){
              this.enabled=false;
              this.enabledFullTarget=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledExcep=false;
              this.enabledFhs = false;
              this.enabledFs = false;
              this.enabledFinishFullTarget=false;
          }else if(row.status === 30){
              if(rowIndex>this.normalLength + this.kpiLength + this.createLength + 3 && rowIndex <=this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5){
              this.enabledExcep=false;
              this.enabledFullTarget=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledFinishFullTarget=false;
            } else{
              this.enabledExcep=true;
              this.enabledFullTarget=true;
              this.enabledHalfTarget=true;
              this.enabledWorkItemCategory=true;
              this.enabledFinishFullTarget=true;
            }
            if(row.source===0){
              this.enabled = true;
              this.enabledHalfTarget=true;
              this.enabledFhs = false;
              this.enabledFs = false;
              this.enabledFinishFullTarget=true;
            }else{
              this.enabled=false;
              this.enabledHalfTarget=true;
              this.enabledWorkItemCategory=true;
              this.enabledExcep=false;
              this.enabledFhs=false;
              this.enabledFs=false;
              this.enabledFinishFullTarget=false;
            }
          }else if(row.status === 20){
            if(row.source===0){
              this.enabled=false;
              this.enabledFullTarget=false;
              this.enabledHalfTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledExcep=false;
              this.enabledFhs=true;
              this.enabledFs=false;
              this.enabledFinishFullTarget=false;
            }else{
              this.enabled=false;
              this.enabledFullTarget=false; //新增工作全年目标不能编辑  zyq
              this.enabledHalfTarget=true; //新增工作半年目标允许编辑  zyq
              this.enabledWorkItemCategory=true;
              this.enabledExcep=false;
              this.enabledFhs=true;
              this.enabledFs=false;
              this.enabledFinishFullTarget=false;
            }
          }else if(row.status===50){
            this.enabled=false;
            this.enabledFullTarget=false;
            this.enabledHalfTarget=false;
            this.enabledWorkItemCategory=false;
            this.enabledExcep=false;
            this.enabledFhs=true;
            this.enabledFs=false;
            this.enabledFinishFullTarget=false;
          }else if(row.status === 40 || row.status===70){
            this.enabled=false;
            this.enabledFullTarget=false;
            this.enabledHalfTarget=false;
            this.enabledWorkItemCategory=false;
            this.enabledExcep=false;
            this.enabledFhs=false;
            this.enabledFs=true;
            this.enabledFinishFullTarget=false;
          }else{
            if(rowIndex>this.normalLength + this.kpiLength + this.createLength + 3 && rowIndex <=this.normalLength + this.kpiLength + this.createLength + this.hrLength + this.ccLength + 5){
              this.enabledExcep=false;
              this.enabledFullTarget=false;
              this.enabledWorkItemCategory=false;
              this.enabledFinishFullTarget=false;
            } else{
              this.enabledExcep=true;
              this.enabledFullTarget=true;
              this.enabledWorkItemCategory=true;
              this.enabledFinishFullTarget=true;
            }
            this.enabled = true;
            this.enabledHalfTarget=true;
            this.enabledFhs = false;
            this.enabledFs = false;
          }
        }else{
          // 预览模式
          this.enabled=false;
          this.enabledFullTarget=false;
          this.enabledHalfTarget=false;
          this.enabledWorkItemCategory=false;
          this.enabledExcep=false;
          this.enabledFhs = false;
          this.enabledFs = false;
          this.enabledFinishFullTarget=false;
        }
        return true;
      },
      commitComplete(row,index) {
        clearInterval(this.timer);
        // this.changeModel("1");
        // this.model = "1";
        this.saveAuto(row,index).then(async()=>{
          const $table = this.$refs.year
          const errMap = await $table.validate(this.tableData[index]).catch(errMap => errMap)
            if(errMap) {
                const msgList = []
                Object.values(errMap).forEach(errList => {
                  errList.forEach(params => {
                    // eslint-disable-next-line no-unused-vars
                    const { rowIndex, column, rules } = params
                    rules.forEach(rule => {
                      // msgList.push(`第 ${rowIndex + 1} 行 ${column.title} 校验错误：${rule.message}`)
                      msgList.push(`${rule.message}`)
                    })
                  })
                })
                this.$message({
                  type: 'error',
                  message: msgList.join()
                })
            }else{
            const status=(row.status==20 || row.status==50)? 35: 55;
            this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, [{
              id: row.id,
              workId: this.workId,
              status: status,
              msgId: this.msgId
            }]).then((res) => {
              if(res.code==0){
                this.$message.success('提交成功');
                this.getList();
              }
            });
          }
        })
      },
      getSummaryData(){
        this.$ajax.get(this.$api.year.yearWork.adu + '/' + this.workId).then((res) => {
        if(res.code==this.$config.ResultCode.SUCCESS_CODE){
            this.summaryData=res.data || {};
          }  
        });
      },
      async multSave(data) {
        data.forEach(t=>{
          t.startDate=this.summaryData.year+'-01-01T00:00:00';
          t.finishDate=this.summaryData.year+'-12-31T00:00:00';
        });
        await this.$ajax.post(this.$api.year.yearWorkDetail.adu, data).then((res) => {
          if(res.code==0){
            this.filterTableData(res.data);
          }else{
           this.$message.error('人力资源和企业文化项保存失败，请手动保存...');
          }
        });
      },
      itemSort(a, b){
          return a.workItemNo-b.workItemNo;
      },
      move(row) {
        this.showHandle = true;
        this.nowClassify = row;
        this.classify = row.workClassify;
      },
      confirmClassify() {
        this.showHandle = false;
        this.$ajax.put(this.$api.year.yearWorkDetail.UpdateWorkClassify, {
          id: this.nowClassify.id,
          workClassify: this.classify,
        }).then(() => {
          this.getList();
          this.$message.success('更改工作分类成功');
        });
      },
      querySearchWeight(_queryString, cb) {
         let weightList = this.weightList;
        // 调用 callback 返回建议列表的数据
        cb(weightList);
      },
      expandKpi() {
        this.setMerge();
        this.expandKpiStatus = !this.expandKpiStatus;
        if (this.expandKpiStatus) {
          this.kpi = _.cloneDeep(this.cloneKpi);
        } else {
          this.cloneKpi = _.cloneDeep(this.kpi);
          this.kpi = [];
        }
      },
      expandNormal() {
        this.setMerge();
        this.expandNormalStatus = !this.expandNormalStatus;
        if (this.expandNormalStatus) {
          this.normal = _.cloneDeep(this.cloneNormal);
        } else {
          this.cloneNormal = _.cloneDeep(this.normal);
          this.normal = [];
        }
      },
      expandCreate() {
        this.setMerge();
        this.expandCreateStatus = !this.expandCreateStatus;
        if (this.expandCreateStatus) {
          this.create = _.cloneDeep(this.cloneCreate);
        } else {
          this.cloneCreate = _.cloneDeep(this.create);
          this.create = [];
        }
      },
      expandHr() {
        this.setMerge();
        this.expandHrStatus = !this.expandHrStatus;
        if (this.expandHrStatus) {
          this.hr = _.cloneDeep(this.cloneHr);
        } else {
          this.cloneHr = _.cloneDeep(this.hr);
          this.hr = [];
        }
      },
      expandCc() {
        this.setMerge();
        this.expandCcStatus = !this.expandCcStatus;
        if (this.expandCcStatus) {
          this.cc = _.cloneDeep(this.cloneCc);
        } else {
          this.cloneCc = _.cloneDeep(this.cc);
          this.cc = [];
        }
      },
      expandPg() {
        this.setMerge();
        this.expandPgStatus = !this.expandPgStatus;
        if (this.expandPgStatus) {
          this.pg = _.cloneDeep(this.clonePg);
        } else {
          this.clonePg = _.cloneDeep(this.pg);
          this.pg = [];
        }
      },
      expandOther() {
        this.setMerge();
        this.expandOtherStatus = !this.expandOtherStatus;
        if (this.expandOtherStatus) {
          this.other = _.cloneDeep(this.cloneOther);
        } else {
          this.cloneOther = _.cloneDeep(this.other);
          this.other = [];
        }
      },
      expandAll(){
       if (!this.expandKpiStatus) {
          this.expandKpiStatus = !this.expandKpiStatus;
          this.kpi = _.cloneDeep(this.cloneKpi);
       }
        if (!this.expandNormalStatus) {
          this.expandNormalStatus = !this.expandNormalStatus;
          this.normal = _.cloneDeep(this.cloneNormal);
        }
      if (!this.expandCreateStatus) {
          this.expandCreateStatus = !this.expandCreateStatus;
          this.create = _.cloneDeep(this.cloneCreate);
        }
       if (!this.expandHrStatus) {
          this.expandHrStatus = !this.expandHrStatus;
          this.hr = _.cloneDeep(this.cloneHr);
        }
       if (!this.expandCcStatus) {
          this.expandCcStatus = !this.expandCcStatus;
          this.cc = _.cloneDeep(this.cloneCc);
        }
       if (!this.expandPgStatus) {
          this.expandPgStatus = !this.expandPgStatus;
          this.pg = _.cloneDeep(this.clonePg);
       }
       if (!this.expandOtherStatus) {
          this.expandOtherStatus = !this.expandOtherStatus;
          this.other = _.cloneDeep(this.cloneOther);
       }
      },
      changeModel(e, submit){
        const arr = this.tableColumn.filter(val => val.property !== undefined);
        let list = [];
        switch (e) {
          case "1":
            list = [];
            if(localStorage.getItem("year_table_herder") && this.editStatus === "edit" && !submit){
              let cache = JSON.parse(localStorage.getItem("year_table_herder"));
              this.tableColumn.forEach(v => {
                cache.forEach(t => {
                  if (v.title == t.title){
                    v.visible = t.visible;
                  }
                })
              });
            }else {
              this.tableColumn.forEach(val => {
                val.visible = true;
              });
            }
            this.isCollapse = false;
            setTimeout(() => {
              this.setPosition();
              // this.observerClass();
            },50);
            break;
          case "2":
            list = ["workItemCategory", "workItemContent","fullTarget", "weight" ,"startDate","finishDate","firstHalfTarget", "finishFullTarget","status", "operation"];
            this.isCollapse = false;
            setTimeout(() => {
              this.setPosition();
              // this.observerClass();
            },50);
            break;
          case "3":
            list = ["workItemCategory", "workItemContent", "fullTarget", "startDate","finishDate","firstHalfTarget", "firstHalfSummary", "status", "operation"];
            this.isCollapse = false;
            setTimeout(() => {
              this.setPosition();
              // this.observerClass();
            },50);
            break;
          case "4":
            list = ["workItemCategory", "workItemContent", "fullTarget", "startDate","finishDate", "finishFullTarget", "fullSummary", "status", "operation"];
            this.isCollapse = false;
            setTimeout(() => {
              this.setPosition();
              // this.observerClass();
            },50);
            break;
          case "5":
            list = ["workItemContent", "firstHalfTarget", "firstHalfSummary","finishFullTarget","fullSummary"];
            this.isCollapse = false;
            this.showCollapse = false;
            break;
        }
        if (list.length) {
          arr.forEach(val => {
            if (list.indexOf(val.property) !== -1){
              val.visible = true;
            }else {
              val.visible = false;
            }
          });
        }
        this.$refs.year.refreshColumn();
      },
      getCategory() {
        this.$ajax.get(this.$api.Identity.Categord.categoryByNo, {userId: sessionStorage.getItem("LOGIN_NAME")}).then(res => {
          const item = res.data||[];
          this.categoryList = this.filterCategory(item.filter(t=>t.status===1));
        });
      },
      queryCategory(queryString, cb) {
        let categoryList = this.categoryList;
        // 调用 callback 返回建议列表的数据
        var results = queryString ? categoryList.filter(this.createFilter(queryString)) : categoryList;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (categoryList) => {
          return (categoryList.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1);
        };
      },
      expandRow({row, rowIndex}) {
        if (row.status === 0 || row.status === 30 || (row.status === 10 && this.editStatus==="approve")){
          if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
          this.$refs.year.updateData(this.tableData);
        }else {
          if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
          this.$refs.year.updateData(this.tableData);
        }
      },
      expandRowAll() {
      if (this.expandRowAllFlag) {
        this.tableData.forEach(val => {
          if (val.workId){
            val.expandRowFlag = false;
          }
        }); 
     }else {
        this.tableData.forEach(val => {
          if (val.workId){
            val.expandRowFlag = true;
          }
        });
      }
      this.expandRowAllFlag = !this.expandRowAllFlag;
      this.$refs.year.updateData(this.tableData);

      this.$nextTick(() => {
        let scrollInfo = this.$refs.year.getScroll();
        this.$refs.year.scrollTo(scrollInfo.scrollLeft, scrollInfo.scrollTop + 1);
      });
    },
      exportExcel(){
        let param = Object.assign({WorkId: this.workId}, this.searchParam)
        this.$ajax.get(this.$api.export.yearPlan, param, {ignore: true, responseType:'blob'}).then((res)=>{
          if(res.data.type == 'application/json'){
            var reader = new FileReader();
            reader.onload = ()=>{
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          }else{
            const filename=Object.keys(this.summaryData).length? this.summaryData.title + '详情' + "(" + this.summaryData.resWkName + ")":'年计划详情';
            const filetype='xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }).catch(() => {})
      },
      preciseExport() {
        this.dialogContent = {
          title: '精确导出',
          componentName: 'export',
          width: '950px',
        };
        this.editData.workId=this.workId;
        this.editData.year=this.summaryData.year;
        this.$refs.addSyncDialog.show();
      },
      closeApprove() {
        this.approveReason = '';
        this.rejectReason = '';
        this.approveRow = null;
      },
      approveText(e) {
        this.approveReason = e;
      },
      rejectText(e) {
        this.rejectReason = e;
      },
      complete(row, rowIndex, status) {
        this.approveRow = _.cloneDeep(row);
        this.$nextTick(()=>{
        if (status === "access") {
            this.approveReason='';
            this.showApprove = true;
          } else {
            this.rejectReason='';
            this.showCompleteApprove = true;
          }
        })
      },
     async getWorkItemStatus() {
       await this.$ajax.get(this.$api.common.getDict, {ItemType: 'YearWorkItemStatus'}).then((res) => {
          if (res.code === 0) {
            this.completeList = res.data && res.data.rows || [];
          }
        });
      },
      getStatusName(val){
        const obj= this.completeList.find(t=>t.itemValue==val);
        return obj?obj.itemDesc:'';
      },
      validateWeight(row){
        let reg = new RegExp("^([1-9]|[1-9]\\d|100)$");
        if(!reg.test(row.weight)) {
          if(row.weight - 0 > 100){
            row.weight = 100;
          }else {
            row.weight = 1;
          }
        }
      },
      downloadTemplate(){
        window.location.href= this.downloadUrl;
      },
      uploadFile({file}){
        const params = new FormData();
        params.append('workId', this.workId);
        params.append('excelfile', file);
        this.$ajax.post(this.$api.year.yearWorkDetail.Import,params,{ headers: { 'Content-Type': 'multipart/form-data;' }}).then((res) => {
            if(res.code===0){
              this.expandAll();
              this.$message.success('上传成功');
              this.getList();
            }
        });
      },
      setMerge() {
          const $table = this.$refs.year;
          const workItemNoColIndex = $table? $table.getColumns().map(p=>p.property).indexOf("workItemNo"): -1;
          const workItemCategoryColIndex = $table? $table.getColumns().map(p=>p.property).indexOf("workItemCategory"): -1;
          const weightColIndex = $table? $table.getColumns().map(p=>p.property).indexOf("weight"): -1;
        if(this.hrLength===0&&this.ccLength===0){
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength},

            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4, col: 0, rowspan: 1, colspan: this.tableColumnLength},

            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + 5, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          ];
          }
          else if(this.hrLength===0){
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4, col: 0, rowspan: 1, colspan: this.tableColumnLength},

            //企业文化第一列合并(NO.)
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: workItemNoColIndex, rowspan: this.orgBuildLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength, col: workItemNoColIndex, rowspan: this.culSpreadLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength, col: workItemNoColIndex, rowspan: this.culActivityLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength + this.culActivityLength, col: workItemNoColIndex, rowspan: this.culPublicityLength, colspan: 1},

            //企业文化第二列合并(类别)
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: workItemCategoryColIndex, rowspan: this.orgBuildLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength, col: workItemCategoryColIndex, rowspan: this.culSpreadLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength, col: workItemCategoryColIndex, rowspan: this.culActivityLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength + this.culActivityLength, col: workItemCategoryColIndex, rowspan: this.culPublicityLength, colspan: 1},

            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + 5, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          ];
          }else if(this.ccLength===0){
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength},

            //人力资源第一列合并(NO.)
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: workItemNoColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: workItemNoColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: workItemNoColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: workItemNoColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: workItemNoColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            //人力资源第二列合并(类别)
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: workItemCategoryColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: workItemCategoryColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: workItemCategoryColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: workItemCategoryColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: workItemCategoryColIndex, rowspan: this.employeeRelationLength, colspan: 1},

           //人力资源第六列合并(权重)
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: weightColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: weightColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: weightColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: weightColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: weightColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4, col: 0, rowspan: 1, colspan: this.tableColumnLength},

            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + 5, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          ];
          }else{
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength},

            //人力资源第一列合并(NO.)
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: workItemNoColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: workItemNoColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: workItemNoColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: workItemNoColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: workItemNoColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            //人力资源第二列合并(类别)
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: workItemCategoryColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: workItemCategoryColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: workItemCategoryColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: workItemCategoryColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: workItemCategoryColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            //人力资源第六列合并(权重)
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: weightColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: weightColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: weightColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: weightColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: weightColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4, col: 0, rowspan: 1, colspan: this.tableColumnLength},

            //企业文化第一列合并(NO.)
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: workItemNoColIndex, rowspan: this.orgBuildLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength, col: workItemNoColIndex, rowspan: this.culSpreadLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength, col: workItemNoColIndex, rowspan: this.culActivityLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength + this.culActivityLength, col: workItemNoColIndex, rowspan: this.culPublicityLength, colspan: 1},

            //企业文化第二列合并(类别)
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: workItemCategoryColIndex, rowspan: this.orgBuildLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength, col: workItemCategoryColIndex, rowspan: this.culSpreadLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength, col: workItemCategoryColIndex, rowspan: this.culActivityLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength + this.culActivityLength, col: workItemCategoryColIndex, rowspan: this.culPublicityLength, colspan: 1},

            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + 5, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          ];
        }
      },
      toWorkscorePage({status}) {
        const param = {
          wkNo: this.summaryData.resWkNo,
          wkName: this.summaryData.resWkName,
          year: this.summaryData.year,
          period: status === 40 ? 6.5 : 13,
          status,
          workId: this.summaryData.id,
          approveReason: this.approveReason,
        };
        // 调用年计划考核表判断接口
        this.$ajax.post(this.$api.period.workScore.canJump, param, {ignore: true}).then(res => {
          if (res.data.code === 0) {
            this.$router.push({
              path: '/personal/workscore/yearDetail',
              query: {
                id: res.data.data.data.id,
                editStatus: 'approve'
              },
            });
          }
        });
      }
    },
    watch: {
      // 'row.fullTarget': {
      //     handler(val) {
      //       if ((this.row.status == 0 || this.row.status == 30) && this.editStatus == 'edit' && this.row.finishFullTarget == '') {
      //         this.$set(this.row, 'finishFullTarget', val);
      //       }
      //     }
      // },
      tableData: {
        handler(val) {
          this.cloneTableData = _.cloneDeep(val);
          if (this.row.id) {
            this.cloneTableData[this.rowIndex].id = this.row.id;
            this.cloneTableData[this.rowIndex].status = this.row.status;
          }
        },
        deep:true,
        immediate: true,
      },
      kpiLength(){
        this.setMerge();
      },
      normalLength(){
        this.setMerge();
      },
      createLength(){
        this.setMerge();
      },
      hrLength(){
        this.setMerge();
      },
      ccLength(){
        this.setMerge();
      },
      pgLength(){
        this.setMerge();
      },
      otherLength(){
        this.setMerge();
      },
      tableColumnLength: {
        handler(){
          const $table = this.$refs.year;
          const workItemNoColIndex = $table? $table.getColumns().map(p=>p.property).indexOf("workItemNo"): -1;
          const workItemCategoryColIndex = $table? $table.getColumns().map(p=>p.property).indexOf("workItemCategory"): -1;
          const weightColIndex = $table? $table.getColumns().map(p=>p.property).indexOf("weight"): -1;
          if(this.hrLength===0&&this.ccLength===0){
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + 5, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          ]
          }else if(this.hrLength===0){
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4, col: 0, rowspan: 1, colspan: this.tableColumnLength},

            //企业文化第一列合并
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: workItemNoColIndex, rowspan: this.orgBuildLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength, col: workItemNoColIndex, rowspan: this.culSpreadLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength, col: workItemNoColIndex, rowspan: this.culActivityLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength + this.culActivityLength, col: workItemNoColIndex, rowspan: this.culPublicityLength, colspan: 1},

            //企业文化第二列合并
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: workItemCategoryColIndex, rowspan: this.orgBuildLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength, col: workItemCategoryColIndex, rowspan: this.culSpreadLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength, col: workItemCategoryColIndex, rowspan: this.culActivityLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength + this.culActivityLength, col: workItemCategoryColIndex, rowspan: this.culPublicityLength, colspan: 1},

            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + 5, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          ]
          }else if(this.ccLength===0){
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength},

            //人力资源第一列合并
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: workItemNoColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: workItemNoColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: workItemNoColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: workItemNoColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: workItemNoColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            //人力资源第二列合并
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: workItemCategoryColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: workItemCategoryColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: workItemCategoryColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: workItemCategoryColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: workItemCategoryColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            //人力资源第六列合并(权重)
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: weightColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: weightColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: weightColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: weightColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: weightColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + 5, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          ]
          }else{
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength},

            //人力资源第一列合并
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: workItemNoColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: workItemNoColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: workItemNoColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: workItemNoColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: workItemNoColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            //人力资源第二列合并
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: workItemCategoryColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: workItemCategoryColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: workItemCategoryColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: workItemCategoryColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: workItemCategoryColIndex, rowspan: this.employeeRelationLength, colspan: 1},
            
            //人力资源第六列合并(权重)
            {row: this.kpiLength + this.normalLength + this.createLength + 4, col: weightColIndex, rowspan: this.riskControlLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength, col: weightColIndex, rowspan: this.employeeLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength, col: weightColIndex, rowspan: this.oecLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength, col: weightColIndex, rowspan: this.trainLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + 4 + this.riskControlLength + this.employeeLength + this.salaryLength + this.oecLength + this.employLength + this.trainLength, col: weightColIndex, rowspan: this.employeeRelationLength, colspan: 1},

            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 4, col: 0, rowspan: 1, colspan: this.tableColumnLength + 5},

            //企业文化第一列合并
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: workItemNoColIndex, rowspan: this.orgBuildLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength, col: workItemNoColIndex, rowspan: this.culSpreadLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength, col: workItemNoColIndex, rowspan: this.culActivityLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength + this.culActivityLength, col: workItemNoColIndex, rowspan: this.culPublicityLength, colspan: 1},

            //企业文化第二列合并
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5, col: workItemCategoryColIndex, rowspan: this.orgBuildLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength, col: workItemCategoryColIndex, rowspan: this.culSpreadLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength, col: workItemCategoryColIndex, rowspan: this.culActivityLength, colspan: 1},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + 5 + this.orgBuildLength + this.culTrainLength + this.culIntegralLength + this.culSpreadLength + this.culActivityLength, col: workItemCategoryColIndex, rowspan: this.culPublicityLength, colspan: 1},

            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + 5, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.kpiLength + this.normalLength + this.createLength + this.hrLength + this.ccLength + this.pgLength + 6, col: 0, rowspan: 1, colspan: this.tableColumnLength},
          ]
          }
        },
        deep:true,
        immediate:true
      },
      showSubmit:{
          handler:function(newValue){
           if(newValue){
            const data=this.tableData.filter(t=>typeof t.id!=='undefined');
            if(data.length===0||data.some(t=>t.status==0||t.status==30)){
              this.tipMsg="计划提交到领导审批后不能更改";
            }else{
              this.tipMsg="总结提交到领导审批";
            }
           }
        },
        immediate: true
      }
    }
  }
</script>
<style scoped lang='scss'>
  .year {
    height: 100%;
    .header {
      .year-no {
        font-weight: bold;
        font-size: 36px;
        color: $--color-primary;
        padding-right: 36px;
        border-right: 1px solid #eaeef4;
      }
      .year-title {
        border-right: 1px solid #eaeef4;
        padding: 0 10px;
        h2 {
          color: $--color-text-primary;
          font-size: 18px;
          font-weight: bold;
          display: inline-block;
        }
        p {
          color: #8e9694;
          margin-top: 16px;
        }
        .saveStatus{
          margin-left: 10px;
          font-size: 15px;
          color: #8e9694;
        }
      }
      .year-right {
        flex: 1 1 auto;
        padding-left: 36px;
        .year-name {
          h2 {
            color: $--color-text-primary;
            font-size: 18px;
            font-weight: bold;
            span {
              font-size: 14px;
              font-weight: normal;
              color: #8e9694;
            }
          }
          p {
            color: $--color-text-primary;
            font-size: 14px;
            margin-top: 16px;
          }
        }
        .year-operation {
          .atb-input {
            .el-form-item {
              margin-bottom: 0;
            }
          }
        }
      }
    }
     ::v-deep .el-tag {
      padding: 0 10px;
      width: auto;
      text-align: center;
    }
    ::v-deep .vxe-cell {
      padding-left: 5px;
      padding-right: 5px;
    }    
    .container {
      margin-top: 15px;
      padding: 0 20px 20px;
      flex: 1;
      .el-icon-arrow-down{
        font-size: 12px;
      }
      .open{
        position: absolute;
        right: 0;
        top: 24px;
        text-align: right;
        font-size: 14px;
        color: #859291;
        cursor: pointer;
      }
      .table-content{
        position: relative;
        .collapse{
          position: absolute;
          cursor: pointer;
          width: 15px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          background-color: rgba(#000, 0.1);
          z-index: 99;
          &:hover{
            background-color: rgba(#000, 0.2);
          }
          i{
            font-size: 14px;
            color: #fff;
          }
        }
      }
      .search {
        position: relative;
        padding-top: 12px;
        padding-right: 56px;
        overflow: auto;
        .function{
          flex-wrap: wrap;
          align-items: center;
        }
        .atb-input{
          display: flex;
          .flex-form-item{
            margin-bottom: 12px;
            display: flex;
            flex: 1;
          }
          .read-mode{
            align-self: flex-end;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            line-height: 1;
            .el-select, .el-autocomplete{
              width: 100%;
            }
          }
        }
      }
      .kpi-content {
        overflow: auto;
        flex-grow: 1;
      }
      ::v-deep .header-table {
        overflow: auto;
        flex-grow: 1;
        user-select: text;
        .vxe-table--header-wrapper {
          background-color: $--bg-color-complete !important;
        }
        .main-row {
          .vxe-cell {
            padding: 0;
          }
        }
      }
      .kpi-add {
        height: 47px;
        background-color: $--color-bg-table-header;
        color: $--color-primary;
        font-size: 14px;
        padding: 0 15px;
        div {
          cursor: pointer;
          span {
            margin-right: 15px;
          }
          i.fold {
            margin-right: 5px;
          }
        }
        span {
          cursor: pointer;
        }
      }
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    ::v-deep .el-input-group__append {
      padding: 0 5px;
    }
  }
   ::v-deep .el-radio-button {
    margin-right: 20px;
    margin-bottom: 15px;
    .el-radio-button__inner {
      border-radius: 20px;
      padding: 0 20px;
      width: 100%;
      line-height: 36px;
      border: 1px solid $--color-primary;
      color: $--color-primary;
    }
  }
  ::v-deep .el-radio-button.is-active .el-radio-button__inner {
    color: $--color-white;
  }
  .program-check {
    li {
      &:not(:last-child) {
        padding-bottom: 20px;
      }
      .el-checkbox__label {
        span {
          font-weight: bold;
        }
      }
      div {
        flex-grow: 1;
        margin-left: 15px;
        p {
          color: $--color-text-primary;
          font-size: 14px;
          &.desc {
            line-height: 1.5;
          }
          &.date {
            line-height: 1;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }

</style>